

const dimensions = {

	'square': {
		'label': 'Square Canvas (1:1)',
		'description': `Classic Brush Ninja, great for Instagram.`,
		'size': [ 512, 512 ],
	},
	'comic': {
		'label': 'Comic Maker Page',
		'description': `Make images that can be used in the Brush Ninja Comic Maker.`,
		'size': [ 210 * 2, 287 * 2 ],
	},
	'traditional': {
		'label': 'Traditional TV (4:3)',
		'description': `For that retro tv look. Works well on Twitter and Facebook.`,
		'size': [ 600, 450 ],
	},
	'widescreen': {
		'label': 'Widescreen TV (16:9)',
		'description': `For dramatic movie style creations.`,
		'size': [ 700, 390 ],
	},
	'cinema': {
		'label': 'Cinema',
		'description': `Half the size of an HD resolution - 1920x1080`,
		'size': [ 960, 540 ],
	},

};

// Do not change.
// Generated by _build/generate-markdown-files.php

const code_2d_examples = {"square":{"title":"Square","content":"\nsetw 5\n\nfunction box {\n\trepeat 4 {\n\t\tforward 200\n\t\tright 90\n\t}\n}\n\nbox()"},"circle":{"title":"Circle","content":"\nsetw 5\n\nfunction circle {\n\trepeat 60 {\n\t\tforward 13\n\t\tright 6 \/\/ 60 times 6 = 360\n\t}\n}\n\ncircle()"},"5 sided star":{"title":"5 Sided Star","content":"\nsetw 5\n\nfunction star {\n\trepeat 5 {\n\t\tfd 100 rt 144\n\t\tfd 100 lt 72 \/\/ 360 \/ 5 sides = 72\n\t}\n}\n\nstar()\n"},"dahlia":{"title":"Dahlia","content":"\n\/\/ Center the shape\npu bk 20 lt 90 fd 125 rt 90 pd\n\n\/\/ Draw the pattern\ncolor yellow\nrepeat 8 {\n\trt 45\n\trepeat 6 {\n\t\trepeat 90 {\n\t\t\tfd 3 rt 2\n\t\t}\n\t\trt 90\n\t}\n}","premium":true},"busy star":{"title":"Busy Star","content":"\n\/\/ Center the content.\npu bk 100 lt 90 fd 100 rt 90 pd\n\n\/\/ Draw the star.\ncolor magenta\nrepeat 18 {\n\trepeat 5 {\n\t\tcolorrand\n\t\trt 40 fd 340 rt 120\n\t}\n\trt 20\n}","premium":true},"fan flower":{"title":"Fan Flower","content":"\n\/\/ Position the cursor\npu\nfd 125 lt 90 fd 25 rt 90\npd\n\n\/\/ Draw the pattern\nrepeat 12 {\n\tcolorrand\n\trepeat 75 {\n\t\tfd 100 bk 100 rt 2\n\t}\n\tfd 250\n}","premium":true},"feathers":{"title":"Feathers","content":"\nrepeat 50 {\n\tcolorrand\n\trepeat rand 20 {\n\t\tfd 80 bk 75 rt 4\n\t}\n\trt 180\n}","premium":true},"squiggles":{"title":"Squiggles","content":"\nrandomize \/\/ Remove this to get the same shape every time.\nrepeat 50 {\n\tfd 10\n\trt rand 70\n\tfd 10\n\tlt rand 70\n}"},"caterpillar":{"title":"Caterpillar","content":"\nrandomize \/\/ Remove this to get the same shape every time.\n\npu sety 400 setx rand 200 312 pd\nsetwidth 100\n\n\/\/ Draw the body.\nrepeat 15 {\n\tfd 10\n\trt rand 20\n\tfd 10\n\tcolorrand\n\tlt rand 20\n}\n\n\/\/ Draw the face\nsetwidth 140 fd 1\n\/\/ Draw antenna\nsetwidth 20\nrt 30 fd 80 bk 80\nlt 60 fd 80 bk 80\nrt 30\n\/\/ Left eye\ncolor white setwidth 20\npu lt 90 fd 30 pd fd 1\ncolor black setwidth 5 bk 1\n\/\/ Right eye\ncolor white setwidth 20\npu bk 60 pd fd 1\ncolor black setwidth 5 bk 1\n\/\/ Mouth\npu fd 30 rt 90 bk 30 lt 90 fd 10\npd bk 20\n\nhidecursor","premium":true},"sausages":{"title":"Sausages","content":"\n\nsetwidth 450\nfd 0\ncolor LightSteelBlue\nsetwidth 350\nfd 0\ncolor white\nsetwidth 340\nfd 0\n\n\/\/ Move to the top left\npu\nsetxy 100 140\nrt 90\n\n\/\/ Set the pen size large.\nsetw 80\n\/\/ Sausage color?\ncolor IndianRed\n\n\/\/ Draw 4 sausages.\nrepeat 3 {\n\tpd\n\tfd 312\n\tbk 312\n\tpu\n\t\/\/ Move down so we can draw the next sausage.\n\tlt 90\n\tbk 110\n\trt 90\n}\n\nhidecursor","premium":true},"waves":{"title":"Waves","content":"\n\/\/ Different each time.\nrandomize\n\n\/\/ Move backwards.\npu bk 300 pd\n\/\/ Fill the screen.\nsetw 700\n\nrepeat 20 {\n\tcolourrand\n\tfd rand 10 50\n\trt rand 0 45\n\tfd rand 10 50\n\tlt rand 0 45\n}","premium":true},"random boxes":{"title":"Random Boxes","content":"\nfunction box {\n\trepeat 4 {\n\t\tfd 50\n\t\trt 90\n\t}\n}\n\nrepeat 20 {\n\t\/\/ Pen up and move to a random position without drawing a line\n\tpu\n\tsetxy random 512 random 512\n\tseta random 90\n\tcolorrand\n\t\/\/ Pen down\n\tpd\n\t\/\/ Draw the box\n\tbox()\n}\n\n"},"love heart":{"title":"Love Heart","content":"\n\/\/ Background colour\nsetbg hotpink\n\/\/ Heart colour\ncolor red\n\npu setxy 256 200 pd\n\n\/\/ Right half of heart\nrepeat 33 {\n\tfd 9 rt 7\n}\nsetxy 256 373\n\n\/\/ Left half of heart\npu setxy 256 200 pd\nseta 270\nrepeat 33 {\n\tfd 9 lt 7\n}\nsetxy 256 373\n\n\/\/ Fill heart\npu setxy 256 256\nfill\n\n\/\/ Randomly position the stars\nrandomize\n\/\/ Star colour\ncolor pink\n\nfunction star {\n\tpu\n\t\/\/ Position random\n\tsetxy rand 0 512 rand 0 512\n\t\/\/ Random angle\n\tseta rand 360\n\tpd\n\trepeat 6 {\n\t\tfd 20 bk 20\n\t\trt 60\n\t}\n}\n\n\/\/ 20 stars\nrepeat 20 {\n\tstar()\n}\n\n\/\/ Border\npu\nsetwidth 8\nsetxy 16 16\ncolor white\nseta 270\npd\n\nrepeat 4 {\n\trt 90 fd 480\n}"},"mar10 day":{"title":"mar10 day","content":"\n\/\/ background\n\/\/ ---\n\/\/ sky\nsetbg #2fc9fd\n\/\/ hills\npu setxy 140 220 setw 240\npd color #add8ea bk 200\npu setxy 370 300\npd color #dccfc7 bk 200\npu setxy 200 400\npd color #dfc472 bk 200\n\/\/ grass\npu setxy 0 470 setw 100\npd color #9ed2bb setxy 512 470\npu setxy 0 520 setw 80\npd color #5a9a04 setxy 512 520\n\n\/\/ body\n\/\/ ---\n\/\/ right arm\npu home pd\ncolor #d6241c\nsetw 50\nfd 40 bk 40\nsetxy 220 256\nsetxy 180 300\n\/\/ hand\nsetw 60\ncolor white\nsetw 50\nfd 0\n\/\/ left arm\ncolor #d6241c\npu home pd\nsetxy 300 256\nsetxy 345 170\n\n\/\/ dungarees\n\/\/ ---\ncolor #205dc4\npu home\nsetw 20\nsetxy 226 236\npd\nbk 50\nfd 50\npu rt 90 fd 60 lt 90 pd\nbk 70\nsetx 280\nsetw 60 setx 232\nbk 20 setx 280\n\/\/ right leg\nsetw 50\npu rt 10 bk 60 pd\nbk 20\ncolor #87341b\nbk 0\ncolor #205dc4\npu fd 20 pd fd 60\n\n\/\/ left leg\npu setxy 226 340\ncolor #205dc4\npd setw 50\nlt 90 fd 20\nlt 110 fd 30\nsetw 10 fd 20\ncolor #87341b\nsetw 45 pd\nrt 130 fd 15\n\n\/\/ hat\n\/\/ ---\npu home\nlt 15\nfd 150\nsetw 200\npd\ncolor #d6241c\nfd 0\ncolor white\npu fd 60 pd\nsetw 70\nfd 0\n\/\/ M logo\npu bk 8 lt 90 fd 15 rt 110 pd\nsetw 10 color #d6241c fd 20 rt 130 fd 15 lt 130 fd 15 rt 130 fd 20\n\n\/\/ face\n\/\/ ---\npu home\nlt 15\nfd 100\nsetw 160\ncolor #fdc5a2\npd fd 0\n\/\/ ears\nsetw 70\nrt 90 fd 64 bk 128\n\/\/ left eye\nfd 40 lt 90\ncolor white setw 30 fd 20 bk 10\ncolor black setw 20 fd 0\n\/\/ right eye\npu rt 90 fd 50 lt 90 bk 10 pd\ncolor white setw 30 fd 20 bk 10\ncolor black setw 20 fd 0\n\/\/ mouth\npu home\nlt 15 fd 60 setw 50 pd color #d6241c fd 0\nsetw 20 lt 90 color white fd 15 bk 30 fd 15\n\/\/ mustache\nrt 90 fd 10 setw 30 rt 80 color #482826 fd 50 bk 50 lt 160 fd 50 bk 50\n\/\/ nose\nrt 80 fd 10 setw 46 color #fdc5a2 fd 0\n\/\/ left sideburn\npu lt 90 fd 75 rt 90 fd 10 pd setw 15\ncolor #482826 fd 35\n\/\/ right sideburn\npu rt 90 fd 150 rt 90 pd fd 35\n\n\n\/\/ hat brim\nbk 50 rt 180 lt 46\ncolor #bb0000 setw 30\nrepeat 11 {\n\tfd 15 lt 9\n}\n\n\/\/ right hand\npu setxy 345 170 pd color white\nsetw 65 fd 0\nsetw 30 rt 100 fd 25\n\nhidecursor\n"},"variable swirls":{"title":"Variable Swirls","content":"\nvar angle 0\nrepeat 600 {\n\tfd 10\n\trt $angle\n\tvar angle add $angle 7\n}"},"random squares":{"title":"Random Squares","content":"\nrandomize\nsetw 5\nrepeat 36 {\n\tcolorrand\n\t\/\/ Pick a random width for each square.\n\tvar side rand 25 300\n\trepeat 4 {\n\t\tfd $side\n\t\trt 90\n\t}\n\trt 10\n}","premium":true},"rainbow corridor":{"title":"Rainbow Corridor","content":"\nvar size 10\nsetw 15\nrepeat 110 {\n\tcolorrand\n\tfd $size\n\trt 90\n\tvar size add $size 5\n}","premium":true},"concentric":{"title":"Concentric","content":"\nvar size 800\nrepeat 16 {\n\tcolorrand\n\tsetw $size\n\tfd 0\n\tvar size minus $size 50\n}"},"arcs 1":{"title":"Arcs 1","content":"\nvar radius 20\nsetw 10\nrepeat 20 {\n\tarc $radius 180\n\trt 180\n\tvar radius sum $radius 20\n}"},"arcs 2":{"title":"Arcs 2","content":"\nvar radius 20\nsetw 8\nrepeat 20 {\n\tcolorrand\n\tarc $radius 180\n\trt rand 0 90\n\tvar radius sum $radius 30\n}","premium":true},"abstract grid":{"title":"Abstract Grid","content":"\nrandomize\nrepeat 100 {\n\tfd random 20 150\n\trt 90\n}","premium":true},"spiral":{"title":"Spiral","content":"\nrt 90\nsetbg darkblue\ncolor yellow\nsetw 5\nvar size 1\nvar gap 10\nrepeat 36 {\n\tarc $size 180\n\tpu\n\tbk $gap\n\tpd\n\trt 180\n\tvar size sum $size $gap\n}\nhidecursor","premium":true},"flower":{"title":"Flower","content":"\nsetw 3\n\nreset()\nrepeat 80 {\n\trt $loopcount\n\tfd 20\n}\n\nreset()\nrepeat 80 {\n\tlt $loopcount\n\tfd 30\n}\n\nreset()\nbk 64\nfd 64\nfd 256\nsetw 100\nfd 0\n\nfunction reset {\n\tpu home setxy 300 380 pd\n}"},"stars":{"title":"Stars","content":"\n\/\/ Create a star shape.\nfunction star {\n\t\/\/ Pick a random size.\n\tvar size random 8 24\n\trepeat 5 {\n\t\tfd $size\n\t\trt 144\n\t}\n}\n\n\/\/ Dark sky\nsetbg darkblue\n\/\/ Yellow stars\ncolor yellow\n\/\/ Thick lines so that stars are filled\nsetw 8\n\n\/\/ 30 stars.\nrepeat 30 {\n\t\/\/ Random position and rotation.\n\tpu setxy random 500 random 500 pd\n\trt random 360\n\t\/\/ Draw the star.\n\tstar()\n}","premium":true},"asteroids":{"title":"Asteroids","content":"\nrandomize\n\npu setxy 5 0 pd\nsetw 5\ncolor #00a\n\/\/ Draw vertical lines.\nrepeat 20 {\n\tbk 532\n\trt 90\n\tfd 25\n\tlt 90\n\tfd 532\n}\n\/\/ Draw horizontal lines.\npu setxy 0 5 pd lt 90\nrepeat 20 {\n\tbk 532\n\tlt 90\n\tfd 25\n\trt 90\n\tfd 532\n}\n\n\/\/ Randomly position and angle the spaceship\npu setxy random 100 400 random 50 100 pd\nseta 45\nrt random 90\nvar angle 30\ncolor white\n\n\/\/ Draw spaceship\nrt 30 bk 20 fd 20\nlt 60 bk 20 fd 20\nrt 30\n\n\/\/ Draw bullets\nrepeat 4 {\n\tpu fd 50 pd\n\tfd 0\n}\n\n\/\/ Draw between 2 and 6 rocks\nrepeat rand 2 6 {\n\trock()\n}\n\n\/\/ Draw up to 3 explosions\nrepeat rand 1 3 {\n\texplode()\n}\n\n\/\/ Draw rock\nfunction rock {\n\tpu setxy random 200 450 random 150 500 pd\n\trt random 360\n\tpd\n\tvar sides random 5 9\n\trepeat $sides {\n\t\tfd 30\n\t\trt divide 360 $sides\n\t}\n}\n\n\/\/ Exploded rocks\nfunction explode {\n\tpu setxy random 0 300 random 150 512 pd\n\trepeat 5 {\n\t\trt random 30 60\n\t\tpu fd 50 pd fd 5\n\t\tpu bk 55\n\t}\n}\n\nhidecursor","premium":true},"zelda pattern":{"title":"Zelda Pattern","content":"\nrandomize\nsetw 8\nsetbg #23574c\ncolor #2e7668\n\n\/\/ Curvy line background.\nrepeat 27 {\n\tvar x times $loopcount 20\n\tpu setx minus $x 35\n\tcurvedLine()\n}\n\n\/\/ Draw random circles\nrepeat random 3 6 {\n\t\/\/ Calculate x and y.\n\t\/\/ Doing it this way places the circles on a grid giving structure to the layout.\n\tvar x random 1 16\n\tvar x multiply $x 32\n\n\tvar y random 1 16\n\tvar y multiply $y 32\n\n\tpu setxy $x $y pd\n\tcircles()\n}\n\n\/\/ Circles\nfunction circles {\n\tvar count random 5 10\n\tvar size times $count 32\n\trepeat $count {\n\t\tsetw $size\n\t\tcolor #2e7668\n\t\tfd 0\n\t\tvar size minus $size 16\n\t\tsetw $size\n\t\tcolor #23574c\n\t\tfd 0\n\t\tvar size minus $size 16\n\t}\n}\n\n\/\/ Curved lines.\nfunction curvedLine {\n\t\/\/ Right curves.\n\tpu sety 0 pd seta 270\n\trt 180\n\trepeat 6 {\n\t\tlt 135 arc 30 95 rt 135\n\t\tpu fd 90 pd\n\t}\n\t\/\/ Left curves.\n\tpu sety 45 seta 270\n\trt 90 fd 40 lt 90\n\trt 180 pd\n\trepeat 6 {\n\t\trt 40 arc 30 95 lt 40\n\t\tpu fd 90 pd\n\t}\n}\nhidecursor","premium":true},"faces":{"title":"Faces","content":"\nrandomize\n\nrepeat 10 {\n\tpu\n\tsetxy random 512 random 512\n\tface()\n}\n\nhidecursor\n\n\/\/ Face\nfunction face {\n\tpd\n\tseta random 250 290\n\tcolor black\n\tsetw 103 fd 0\n\tcolor lightsalmon\n\tsetw 100 fd 0\n\n\tpu fd 10 rt 90 fd 20 pd\n\teye()\n\n\tpu bk 40 pd\n\teye()\n\n\tpu fd 20 lt 90\n\tbk 20 rt 90\n\tfd 10 pd setw 6 bk 20\n\tseta 270\n}\n\n\/\/ Eye\nfunction eye {\n\tsetw 20 color white fd 0\n\tsetw 12 color black fd 0\n}","premium":true},"mario day 2024":{"title":"Mario Day 2024","content":"\nvar pixelSize 34\npu\n\n\/\/ row 0\nvar x times $pixelSize 4\nvar y 0\n\ncolor red repeat 5 { pixel() }\ncolor transparent repeat 2 { pixel() }\ncolor lightsalmon repeat 3 { pixel() }\n\n\/\/ row 1\nvar x times $pixelSize 3\nvar y $pixelSize\n\ncolor red repeat 9 { pixel() }\ncolor lightsalmon repeat 2 { pixel() }\n\n\/\/ row 2\nvar x times $pixelSize 3\nvar y times $pixelSize 2\n\ncolor brown repeat 3 { pixel() }\ncolor lightsalmon repeat 2 { pixel() }\ncolor black pixel()\ncolor lightsalmon pixel()\nvar x add $x $pixelSize\ncolor red repeat 3 { pixel() }\n\n\/\/ row 3\nvar x times $pixelSize 2\nvar y times $pixelSize 3\n\ncolor brown pixel()\ncolor lightsalmon pixel()\ncolor brown pixel()\ncolor lightsalmon repeat 3 { pixel() }\ncolor black pixel()\ncolor lightsalmon repeat 3 { pixel() }\ncolor red repeat 2 { pixel() }\n\n\/\/ row 4\nvar x times $pixelSize 2\nvar y times $pixelSize 4\n\ncolor brown pixel()\ncolor lightsalmon pixel()\ncolor brown pixel() pixel()\ncolor lightsalmon repeat 3 { pixel() }\ncolor black pixel()\ncolor lightsalmon repeat 3 { pixel() }\ncolor red pixel()\n\n\/\/ row 5\nvar x times $pixelSize 2\nvar y times $pixelSize 5\n\ncolor brown pixel() pixel()\ncolor lightsalmon repeat 4 { pixel() }\ncolor black repeat 4 { pixel() }\ncolor red pixel()\n\n\/\/ row 6\nvar x times $pixelSize 4\nvar y times $pixelSize 6\n\ncolor lightsalmon repeat 7 { pixel() }\ncolor red repeat 2 { pixel() }\n\n\/\/ row 7\nvar x $pixelSize\nvar y times $pixelSize 7\n\ncolor red repeat 4 { pixel() }\ncolor blue pixel()\ncolor red repeat 3 { pixel() }\ncolor blue pixel()\ncolor red repeat 2 { pixel() }\nvar x add $x $pixelSize\nvar x add $x $pixelSize\ncolor brown pixel()\n\n\/\/ row 8\nvar x 0\nvar y times $pixelSize 8\n\ncolor lightsalmon pixel()\ncolor red repeat 5 { pixel() }\ncolor blue pixel()\ncolor red repeat 3 { pixel() }\ncolor blue pixel()\nvar x add $x $pixelSize\nvar x add $x $pixelSize\ncolor brown pixel() pixel()\n\n\/\/ row 9\nvar x 0\nvar y times $pixelSize 9\n\ncolor lightsalmon pixel() pixel()\ncolor red repeat 4 { pixel() }\ncolor blue repeat 4 { pixel() }\ncolor yellow pixel()\ncolor blue repeat 2 { pixel() }\ncolor brown pixel() pixel()\n\n\/\/ row 10\nvar x times $pixelSize 3\nvar y times $pixelSize 10\n\ncolor blue repeat 4 { pixel() }\ncolor yellow pixel()\ncolor blue repeat 5 { pixel() }\ncolor brown pixel() pixel()\n\n\/\/ row 11\nvar x times $pixelSize 1\nvar y times $pixelSize 11\n\ncolor brown repeat 2 { pixel() }\ncolor blue repeat 10 { pixel() }\ncolor brown pixel() pixel()\n\n\/\/ row 12\nvar x 0\nvar y times $pixelSize 12\n\ncolor brown repeat 3 { pixel() }\ncolor blue repeat 6 { pixel() }\n\n\/\/ row 13\nvar x 0\nvar y times $pixelSize 13\n\ncolor brown repeat 2 { pixel() }\n\nfunction pixel {\n\tpu\n\tsetxy $x $y\n\tpd\n\tseta 270\n\t\/\/ Draw square\n\trepeat 4 {\n\t\trt 90\n\t\tfd $pixelSize\n\t}\n\t\/\/ Fill square\n\tpu\n\trt 135 fd 5\n\tfill\n\t\/\/ Increase x position\n\tvar x add $x $pixelSize\n}"}};


const myArray = {

	/**
	 * Deep clone a multi dimensional array.
	 *
	 * @param {array} arr The array to deep clone.
	 * @return {array}
	 */
	clone: function( arr ) {

		// Quickly duplicate the current array creating a new array.
		// @see https://stackoverflow.com/a/5024103/1904139
		let newArr = arr.slice( 0 );

		for ( let i = 0; i < newArr.length; i++ ) {
			// If array then recursively clone.
			// Arrays are of type `object`.
			if ( 'object' === typeof newArr[ i ] ) {
				newArr[ i ] = myArray.clone( newArr[ i ] );
			}
		}

		return newArr;

	},


	/**
	 * Create a unique array.
	 *
	 * @param {array} arr The array to make unique.
	 * @return {array}
	 */
	unique: function( arr ) {

		return [ ...new Set( arr ) ];

	},

};


// const test = [
// 	0,
// 	[ 1, 2, 3 ],
// 	[ 4, 5, 6 ],
// 	7,
// 	8
// ];

// console.log( myArray.clone( test ) );

///=include ./helpers/code-editor.js
///=include ./helpers/code-highlighting.js
/**
 * Convert a CSS color to a 32bit integer.
 * Uses a 1x1 canvas to convert the colour.
 * Supports any valid CSS color.
 */
const convertColor = {

	/**
	 * Canvas context.
	 */
	ctx: null,


	/**
	 * Create the canvas context.
	 *
	 * @return {void}
	 */
	init: function() {

		if ( convertColor.ctx ) {
			return;
		}

		convertColor.ctx = document.createElement( 'canvas' ).getContext( '2d' );
		convertColor.ctx.canvas.width = 1;
		convertColor.ctx.canvas.height = 1;

	},


	/**
	 * Convert the CSS color to a 32bit integer.
	 *
	 * @param {string} cssColor The css color to convert. Can be any valid CSS color.
	 * @return {number}
	 */
	run: function( cssColor ) {

		convertColor.init();

		convertColor.ctx.clearRect( 0, 0, 1, 1 );
		convertColor.ctx.fillStyle = cssColor;
		convertColor.ctx.fillRect( 0, 0, 1, 1 );

		const imgData = convertColor.ctx.getImageData( 0, 0, 1, 1 );

		return new Uint32Array( imgData.data.buffer )[ 0 ];

	}

};

/**
 * Is this 'thing' a number?
 *
 * @see https://stackoverflow.com/questions/600763/check-if-a-variable-contains-a-numerical-value-in-javascript/601877#601877
 * @param {any} temp The item to test.
 * @return {boolean}
 */
function isNumber( temp ) {

	return isFinite( String( temp ).trim() || NaN )

}


/**
 * Is this 'thing' a string?
 *
 * @param {any} temp The item to test.
 * @return {boolean}
 */
function isString( temp ) {

	return 'string' === typeof temp;

}


/**
 * Is this 'thing' an array?
 *
 * @param {any} temp The item to test.
 * @return {boolean}
 */
function isArray( temp ) {

	if ( !temp ) {
		return false;
	}

	if ( temp.constructor ) {
		return temp.constructor === Array;
	}

	return false;

}

/**
 * Convert radians to degrees.
 *
 * @param {number} radians The amount of radians to convert.
 * @return {number}
 */
function radians_to_degrees( radians ) {

	return radians * ( 180 / Math.PI );

}


/**
 * Convert degrees to radians.
 *
 * @param {number} degrees The amount of degrees to convert.
 * @return {number}
 */
function degrees_to_radians( degrees ) {

	return degrees * ( Math.PI / 180 );

}

/**
 * Generate repeatable random numbers.
 */
const random = {


	/**
	 * Set the random seed.
	 */
	seed: 0,


	/**
	 * Generate a random number using a random seed so that we can get consistent behaviour.
	 *
	 * @return {number}
	 */
	gen: function() {

		this.seed++;

		var x = Math.sin( this.seed ) * 10000;

		return x - Math.floor( x );

	},


	/**
	 * Generate a random integer between 2 values.
	 *
	 * @param {number} num1 Range value 1.
	 * @param {number} num2 Range value 2.
	 * @return {int}
	 */
	integer: function( num1 = 100, num2 = 0 ) {

		const min = Math.min( num1, num2 );
		const max = Math.max( num1, num2 );

		return Math.floor( random.gen() * ( max - min + 1 ) + min );

	},


	/**
	 * Generate a random number (float) between 2 numbers.
	 *
	 * @param {number} num1 Range value 1.
	 * @param {number} num2 Range value 2.
	 * @return {float}
	 */
	number: function( num1 = 100, num2 = 0 ) {

		const min = Math.min( num1, num2 );
		const max = Math.max( num1, num2 );

		return random.gen() * ( max - min ) + min;

	},


	/**
	 * Set a random seed.
	 *
	 * @return {number}
	 */
	random_seed: function() {

		let d = new Date();
		let seed = d.getTime().toString();
		this.seed = Math.round( seed.substring( seed.length - 5 ) );

		return this.seed;

	},


	/**
	 * Check against a probability chance of doing something.
	 *
	 * @param {number} chance The percentage chance to check against.
	 * @return {boolean}
	 */
	percent: function( chance ) {

		let number = this.gen() * 100;

		if ( number < chance ) {
			return true;
		}

		return false;

	},


};

/**
 * Capitalize the first letter in a string.
 *
 * @param {string} string The string to capitalize.
 * @return {string}
 */
function capitalizeFirstLetter( string ) {

	return string.charAt( 0 ).toUpperCase() + string.slice( 1 );

}


/**
 * Left pad a number with zeros.
 *
 * @param {int} number The number to pad.
 * @param {int} length The desired length of the number.
 * @return {string}
 */
function zeroPadNumber( number, length ) {

	return number.toString().padStart( length, '0' );

}


/**
 * Convert a url into a nice clean string.
 *
 * @param {string} name The name to convert into a nice string.
 * @return {string}
 */
function urlString( name ) {

	if ( !name ) {
		return '';
	}

	return name
		.replace( /[^a-z0-9]/gi, ' ' ) // Ensure only valid characters.
		.trim() // Trim whitespace.
		.replace( /  +/g, ' ' ) // Remove duplicate spaces.
		.replace( / +/g, '-' ) // Replace spaces with a dash.
		.toLowerCase(); // Lowercase.

}
const shareModal = {

	shareOptions: {
		facebook: {
			title: 'Share on Facebook',
			label: 'Share',
			url: 'https://facebook.com/sharer/sharer.php?u=%u',
			color: '3b5998'
		},
		twitter: {
			title: 'Tweet on Twitter',
			label: 'Tweet',
			url: 'https://twitter.com/intent/tweet?text=%m',
			color: '1da1f2'
		},
		reddit: {
			title: 'Share on Reddit',
			label: 'Share',
			url: 'https://reddit.com/submit?url=%u',
			color: 'ff4500'
		},
		tumblr: {
			title: 'Share on Tumblr',
			label: 'Share',
			url: 'https://tumblr.com/widgets/share/tool?canonicalUrl=%u&content=%m',
			color: '35465c'
		},
		email: {
			title: 'Send via Email',
			label: 'Send',
			url: 'mailto:somebody@example.com?body=%m',
			color: '483d8b'
		}
	},

	/**
	 * The message to share.
	 * The following placeholders can be used:
	 * %s will be replaced with the current url.
	 * %u will be replaced with the current url.
	 * %m will be replaced with the message.
	 */
	message: 'I just created some cool art with Brush Ninja! 🎨🖌️ It\'s a fun and easy-to-use tool that works right in your browser. No sign up needed. Start Creating! %s',

	/**
	 * The url to share.
	 */
	shareUrl: '',


	/**
	 *
	 */
	show: function( title = 'Saved', content = '' ) {

		const share_m = modal.showGeneral( title );

		share_m.innerHTML = shareModal.template( content );

		// Generate the share url.
		shareModal.setUrl();

	},


	/**
	 * The share template.
	 *
	 * @param {string} content
	 * @return {string}
	 */
	template: function( content = '', closeButton = true ) {

		if ( content.length ) {
			content = `<div class="f4 m-y4 f-fw700">${content}</div>`;
		}

		shareModal.setUrl();

		let shareButtons = '';

		// Loop through shareModal.shareOptions and create javascript links
		Object.keys( shareModal.shareOptions ).forEach(
			function( shareOption ) {

				const share = shareModal.shareOptions[ shareOption ];

				const styles = [
					'-webkit-mask: center no-repeat;',
					'mask: center no-repeat;',
					'-webkit-mask-size: contain;',
					'mask-size: contain;',
					`-webkit-mask-image: url(/assets/images/social/${shareOption.toLowerCase()}.svg);`,
					`mask-image: url(/assets/images/social/${shareOption.toLowerCase()}.svg);`,
					'background: white;',
					'width: 1.5rem;',
					'height: 1.5rem;',
				];

				shareButtons += `
				<a
					class="bg-${shareOption} f-fw700 p2 b-br1 flex-g1 flex flex-jc-c flex-ai-c"
					style="background: #${share.color}; color: #fff;"
					href="${sanitize.attr( shareModal.processUrl( share.url ) )}"
					target="_blank"
					rel="noopener"
					title="${share.title}">
					<span class="icon-mask" style="${styles.join( ' ' )}"></span>
					<span class="screen-reader-text">${share.label}</span>
				</a>`;

			}
		);

		return `
			${content}
			<div class="bg-yellow b-br2 p4">
				<h2 class="f-fw700 m-y2 fg-black f4">Proud of your Brush Ninja creation?</h2>
				<p class="m-y2">Share it with your friends ⬇️</p>
				<div class="flex gap2 m-y3">${shareButtons}</div>
			</div>
			${closeButton ? '<button class="bg-blue f-fw700 m-t4" onclick="modal.close()">Create More &rarr;</button>' : ''}
		`;

		// <div class="b p2 b-br1 m-y3">${sanitize.html( shareModal.message.replace( '%s', window.location.href ) )}</div>

		// 	<div class="flex gap2 m-y4">
		// 	<input class="flex-g1 m0" value="${sanitize.url( window.location.href )}" readonly>
		// 	<button class="bg-blue f-fw700" onclick="shareModal.copyLink()">Copy url</button>
		// </div>

	},


	/**
	 * Process the url.
	 *
	 * @param {string} url
	 * @return {string}
	 */
	processUrl: function( url ) {

		shareModal.setUrl();

		const message = shareModal.message.replace( '%s', shareModal.shareUrl );

		url = url.replace( '%u', encodeURIComponent( shareModal.shareUrl ) );
		url = url.replace( '%m', encodeURIComponent( message ) );

		return url;

	},


	/**
	 * Generate the shareUrl value.
	 *
	 * @return {void}
	 */
	setUrl: function() {

		if ( shareModal.shareUrl.length ) {
			return;
		}

		// Get canonical url.
		const canonical = document.querySelector( 'link[rel="canonical"]' );

		if ( canonical ) {
			shareModal.shareUrl = canonical.href;
			return;
		}

		shareModal.shareUrl = window.location.href;

	},

};



/*global define:false */

/**

 * Copyright 2012-2017 Craig Campbell

 *

 * Licensed under the Apache License, Version 2.0 (the "License");

 * you may not use this file except in compliance with the License.

 * You may obtain a copy of the License at

 *

 * http://www.apache.org/licenses/LICENSE-2.0

 *

 * Unless required by applicable law or agreed to in writing, software

 * distributed under the License is distributed on an "AS IS" BASIS,

 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.

 * See the License for the specific language governing permissions and

 * limitations under the License.

 *

 * Mousetrap is a simple keyboard shortcut library for Javascript with

 * no external dependencies

 *

 * @version 1.6.5

 * @url craig.is/killing/mice

 */

( function( window, document, undefined ) {



	// Check if mousetrap is used inside browser, if not, return

	if ( !window ) {

		return;

	}



    /**

     * mapping of special keycodes to their corresponding keys

     *

     * everything in this dictionary cannot use keypress events

     * so it has to be here to map to the correct keycodes for

     * keyup/keydown events

     *

     * @type {Object}

     */

	var _MAP = {

		8: 'backspace',

		9: 'tab',

		13: 'enter',

		16: 'shift',

		17: 'ctrl',

		18: 'alt',

		20: 'capslock',

		27: 'esc',

		32: 'space',

		33: 'pageup',

		34: 'pagedown',

		35: 'end',

		36: 'home',

		37: 'left',

		38: 'up',

		39: 'right',

		40: 'down',

		45: 'ins',

		46: 'del',

		91: 'meta',

		93: 'meta',

		224: 'meta'

	};



    /**

     * mapping for special characters so they can support

     *

     * this dictionary is only used incase you want to bind a

     * keyup or keydown event to one of these keys

     *

     * @type {Object}

     */

	var _KEYCODE_MAP = {

		106: '*',

		107: '+',

		109: '-',

		110: '.',

		111: '/',

		186: ';',

		187: '=',

		188: ',',

		189: '-',

		190: '.',

		191: '/',

		192: '`',

		219: '[',

		220: '\\',

		221: ']',

		222: '\''

	};



    /**

     * this is a mapping of keys that require shift on a US keypad

     * back to the non shift equivelents

     *

     * this is so you can use keyup events with these keys

     *

     * note that this will only work reliably on US keyboards

     *

     * @type {Object}

     */

	var _SHIFT_MAP = {

		'~': '`',

		'!': '1',

		'@': '2',

		'#': '3',

		'$': '4',

		'%': '5',

		'^': '6',

		'&': '7',

		'*': '8',

		'(': '9',

		')': '0',

		'_': '-',

		'+': '=',

		':': ';',

		'\"': '\'',

		'<': ',',

		'>': '.',

		'?': '/',

		'|': '\\'

	};



    /**

     * this is a list of special strings you can use to map

     * to modifier keys when you specify your keyboard shortcuts

     *

     * @type {Object}

     */

	var _SPECIAL_ALIASES = {

		'option': 'alt',

		'command': 'meta',

		'return': 'enter',

		'escape': 'esc',

		'plus': '+',

		'mod': /Mac|iPod|iPhone|iPad/.test( navigator.platform ) ? 'meta' : 'ctrl'

	};



    /**

     * variable to store the flipped version of _MAP from above

     * needed to check if we should use keypress or not when no action

     * is specified

     *

     * @type {Object|undefined}

     */

	var _REVERSE_MAP;



    /**

     * loop through the f keys, f1 to f19 and add them to the map

     * programatically

     */

	for ( var i = 1; i < 20; ++i ) {

		_MAP[ 111 + i ] = 'f' + i;

	}



    /**

     * loop through to map numbers on the numeric keypad

     */

	for ( i = 0; i <= 9; ++i ) {



		// This needs to use a string cause otherwise since 0 is falsey

		// mousetrap will never fire for numpad 0 pressed as part of a keydown

		// event.

		//

		// @see https://github.com/ccampbell/mousetrap/pull/258

		_MAP[ i + 96 ] = i.toString();

	}



    /**

     * cross browser add event method

     *

     * @param {Element|HTMLDocument} object

     * @param {string} type

     * @param {Function} callback

     * @returns void

     */

	function _addEvent( object, type, callback ) {

		if ( object.addEventListener ) {

			object.addEventListener( type, callback, false );

			return;

		}



		object.attachEvent( 'on' + type, callback );

	}



    /**

     * takes the event and returns the key character

     *

     * @param {Event} e

     * @return {string}

     */

	function _characterFromEvent( e ) {



		// for keypress events we should return the character as is

		if ( e.type == 'keypress' ) {

			var character = String.fromCharCode( e.which );



			// if the shift key is not pressed then it is safe to assume

			// that we want the character to be lowercase.  this means if

			// you accidentally have caps lock on then your key bindings

			// will continue to work

			//

			// the only side effect that might not be desired is if you

			// bind something like 'A' cause you want to trigger an

			// event when capital A is pressed caps lock will no longer

			// trigger the event.  shift+a will though.

			if ( !e.shiftKey ) {

				character = character.toLowerCase();

			}



			return character;

		}



		// for non keypress events the special maps are needed

		if ( _MAP[ e.which ] ) {

			return _MAP[ e.which ];

		}



		if ( _KEYCODE_MAP[ e.which ] ) {

			return _KEYCODE_MAP[ e.which ];

		}



		// if it is not in the special map



		// with keydown and keyup events the character seems to always

		// come in as an uppercase character whether you are pressing shift

		// or not.  we should make sure it is always lowercase for comparisons

		return String.fromCharCode( e.which ).toLowerCase();

	}



    /**

     * checks if two arrays are equal

     *

     * @param {Array} modifiers1

     * @param {Array} modifiers2

     * @returns {boolean}

     */

	function _modifiersMatch( modifiers1, modifiers2 ) {

		return modifiers1.sort().join( ',' ) === modifiers2.sort().join( ',' );

	}



    /**

     * takes a key event and figures out what the modifiers are

     *

     * @param {Event} e

     * @returns {Array}

     */

	function _eventModifiers( e ) {

		var modifiers = [];



		if ( e.shiftKey ) {

			modifiers.push( 'shift' );

		}



		if ( e.altKey ) {

			modifiers.push( 'alt' );

		}



		if ( e.ctrlKey ) {

			modifiers.push( 'ctrl' );

		}



		if ( e.metaKey ) {

			modifiers.push( 'meta' );

		}



		return modifiers;

	}



    /**

     * prevents default for this event

     *

     * @param {Event} e

     * @returns void

     */

	function _preventDefault( e ) {

		if ( e.preventDefault ) {

			e.preventDefault();

			return;

		}



		e.returnValue = false;

	}



    /**

     * stops propogation for this event

     *

     * @param {Event} e

     * @returns void

     */

	function _stopPropagation( e ) {

		if ( e.stopPropagation ) {

			e.stopPropagation();

			return;

		}



		e.cancelBubble = true;

	}



    /**

     * determines if the keycode specified is a modifier key or not

     *

     * @param {string} key

     * @returns {boolean}

     */

	function _isModifier( key ) {

		return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';

	}



    /**

     * reverses the map lookup so that we can look for specific keys

     * to see what can and can't use keypress

     *

     * @return {Object}

     */

	function _getReverseMap() {

		if ( !_REVERSE_MAP ) {

			_REVERSE_MAP = {};

			for ( var key in _MAP ) {



				// pull out the numeric keypad from here cause keypress should

				// be able to detect the keys from the character

				if ( key > 95 && key < 112 ) {

					continue;

				}



				if ( _MAP.hasOwnProperty( key ) ) {

					_REVERSE_MAP[ _MAP[ key ] ] = key;

				}

			}

		}

		return _REVERSE_MAP;

	}



    /**

     * picks the best action based on the key combination

     *

     * @param {string} key - character for key

     * @param {Array} modifiers

     * @param {string=} action passed in

     */

	function _pickBestAction( key, modifiers, action ) {



		// if no action was picked in we should try to pick the one

		// that we think would work best for this key

		if ( !action ) {

			action = _getReverseMap()[ key ] ? 'keydown' : 'keypress';

		}



		// modifier keys don't work as expected with keypress,

		// switch to keydown

		if ( action == 'keypress' && modifiers.length ) {

			action = 'keydown';

		}



		return action;

	}



    /**

     * Converts from a string key combination to an array

     *

     * @param  {string} combination like "command+shift+l"

     * @return {Array}

     */

	function _keysFromString( combination ) {

		if ( combination === '+' ) {

			return [ '+' ];

		}



		combination = combination.replace( /\+{2}/g, '+plus' );

		return combination.split( '+' );

	}



    /**

     * Gets info for a specific key combination

     *

     * @param  {string} combination key combination ("command+s" or "a" or "*")

     * @param  {string=} action

     * @returns {Object}

     */

	function _getKeyInfo( combination, action ) {

		var keys;

		var key;

		var i;

		var modifiers = [];



		// take the keys from this pattern and figure out what the actual

		// pattern is all about

		keys = _keysFromString( combination );



		for ( i = 0; i < keys.length; ++i ) {

			key = keys[ i ];



			// normalize key names

			if ( _SPECIAL_ALIASES[ key ] ) {

				key = _SPECIAL_ALIASES[ key ];

			}



			// if this is not a keypress event then we should

			// be smart about using shift keys

			// this will only work for US keyboards however

			if ( action && action != 'keypress' && _SHIFT_MAP[ key ] ) {

				key = _SHIFT_MAP[ key ];

				modifiers.push( 'shift' );

			}



			// if this key is a modifier then add it to the list of modifiers

			if ( _isModifier( key ) ) {

				modifiers.push( key );

			}

		}



		// depending on what the key combination is

		// we will try to pick the best event for it

		action = _pickBestAction( key, modifiers, action );



		return {

			key: key,

			modifiers: modifiers,

			action: action

		};

	}



	function _belongsTo( element, ancestor ) {

		if ( element === null || element === document ) {

			return false;

		}



		if ( element === ancestor ) {

			return true;

		}



		return _belongsTo( element.parentNode, ancestor );

	}



	function Mousetrap( targetElement ) {

		var self = this;



		targetElement = targetElement || document;



		if ( !( self instanceof Mousetrap ) ) {

			return new Mousetrap( targetElement );

		}



        /**

         * element to attach key events to

         *

         * @type {Element}

         */

		self.target = targetElement;



        /**

         * a list of all the callbacks setup via Mousetrap.bind()

         *

         * @type {Object}

         */

		self._callbacks = {};



        /**

         * direct map of string combinations to callbacks used for trigger()

         *

         * @type {Object}

         */

		self._directMap = {};



        /**

         * keeps track of what level each sequence is at since multiple

         * sequences can start out with the same sequence

         *

         * @type {Object}

         */

		var _sequenceLevels = {};



        /**

         * variable to store the setTimeout call

         *

         * @type {null|number}

         */

		var _resetTimer;



        /**

         * temporary state where we will ignore the next keyup

         *

         * @type {boolean|string}

         */

		var _ignoreNextKeyup = false;



        /**

         * temporary state where we will ignore the next keypress

         *

         * @type {boolean}

         */

		var _ignoreNextKeypress = false;



        /**

         * are we currently inside of a sequence?

         * type of action ("keyup" or "keydown" or "keypress") or false

         *

         * @type {boolean|string}

         */

		var _nextExpectedAction = false;



        /**

         * resets all sequence counters except for the ones passed in

         *

         * @param {Object} doNotReset

         * @returns void

         */

		function _resetSequences( doNotReset ) {

			doNotReset = doNotReset || {};



			var activeSequences = false,

				key;



			for ( key in _sequenceLevels ) {

				if ( doNotReset[ key ] ) {

					activeSequences = true;

					continue;

				}

				_sequenceLevels[ key ] = 0;

			}



			if ( !activeSequences ) {

				_nextExpectedAction = false;

			}

		}



        /**

         * finds all callbacks that match based on the keycode, modifiers,

         * and action

         *

         * @param {string} character

         * @param {Array} modifiers

         * @param {Event|Object} e

         * @param {string=} sequenceName - name of the sequence we are looking for

         * @param {string=} combination

         * @param {number=} level

         * @returns {Array}

         */

		function _getMatches( character, modifiers, e, sequenceName, combination, level ) {

			var i;

			var callback;

			var matches = [];

			var action = e.type;



			// if there are no events related to this keycode

			if ( !self._callbacks[ character ] ) {

				return [];

			}



			// if a modifier key is coming up on its own we should allow it

			if ( action == 'keyup' && _isModifier( character ) ) {

				modifiers = [ character ];

			}



			// loop through all callbacks for the key that was pressed

			// and see if any of them match

			for ( i = 0; i < self._callbacks[ character ].length; ++i ) {

				callback = self._callbacks[ character ][ i ];



				// if a sequence name is not specified, but this is a sequence at

				// the wrong level then move onto the next match

				if ( !sequenceName && callback.seq && _sequenceLevels[ callback.seq ] != callback.level ) {

					continue;

				}



				// if the action we are looking for doesn't match the action we got

				// then we should keep going

				if ( action != callback.action ) {

					continue;

				}



				// if this is a keypress event and the meta key and control key

				// are not pressed that means that we need to only look at the

				// character, otherwise check the modifiers as well

				//

				// chrome will not fire a keypress if meta or control is down

				// safari will fire a keypress if meta or meta+shift is down

				// firefox will fire a keypress if meta or control is down

				if ( ( action == 'keypress' && !e.metaKey && !e.ctrlKey ) || _modifiersMatch( modifiers, callback.modifiers ) ) {



					// when you bind a combination or sequence a second time it

					// should overwrite the first one.  if a sequenceName or

					// combination is specified in this call it does just that

					//

					// @todo make deleting its own method?

					var deleteCombo = !sequenceName && callback.combo == combination;

					var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;

					if ( deleteCombo || deleteSequence ) {

						self._callbacks[ character ].splice( i, 1 );

					}



					matches.push( callback );

				}

			}



			return matches;

		}



        /**

         * actually calls the callback function

         *

         * if your callback function returns false this will use the jquery

         * convention - prevent default and stop propogation on the event

         *

         * @param {Function} callback

         * @param {Event} e

         * @returns void

         */

		function _fireCallback( callback, e, combo, sequence ) {



			// if this event should not happen stop here

			if ( self.stopCallback( e, e.target || e.srcElement, combo, sequence ) ) {

				return;

			}



			if ( callback( e, combo ) === false ) {

				_preventDefault( e );

				_stopPropagation( e );

			}

		}



        /**

         * handles a character key event

         *

         * @param {string} character

         * @param {Array} modifiers

         * @param {Event} e

         * @returns void

         */

		self._handleKey = function( character, modifiers, e ) {

			var callbacks = _getMatches( character, modifiers, e );

			var i;

			var doNotReset = {};

			var maxLevel = 0;

			var processedSequenceCallback = false;



			// Calculate the maxLevel for sequences so we can only execute the longest callback sequence

			for ( i = 0; i < callbacks.length; ++i ) {

				if ( callbacks[ i ].seq ) {

					maxLevel = Math.max( maxLevel, callbacks[ i ].level );

				}

			}



			// loop through matching callbacks for this key event

			for ( i = 0; i < callbacks.length; ++i ) {



				// fire for all sequence callbacks

				// this is because if for example you have multiple sequences

				// bound such as "g i" and "g t" they both need to fire the

				// callback for matching g cause otherwise you can only ever

				// match the first one

				if ( callbacks[ i ].seq ) {



					// only fire callbacks for the maxLevel to prevent

					// subsequences from also firing

					//

					// for example 'a option b' should not cause 'option b' to fire

					// even though 'option b' is part of the other sequence

					//

					// any sequences that do not match here will be discarded

					// below by the _resetSequences call

					if ( callbacks[ i ].level != maxLevel ) {

						continue;

					}



					processedSequenceCallback = true;



					// keep a list of which sequences were matches for later

					doNotReset[ callbacks[ i ].seq ] = 1;

					_fireCallback( callbacks[ i ].callback, e, callbacks[ i ].combo, callbacks[ i ].seq );

					continue;

				}



				// if there were no sequence matches but we are still here

				// that means this is a regular match so we should fire that

				if ( !processedSequenceCallback ) {

					_fireCallback( callbacks[ i ].callback, e, callbacks[ i ].combo );

				}

			}



			// if the key you pressed matches the type of sequence without

			// being a modifier (ie "keyup" or "keypress") then we should

			// reset all sequences that were not matched by this event

			//

			// this is so, for example, if you have the sequence "h a t" and you

			// type "h e a r t" it does not match.  in this case the "e" will

			// cause the sequence to reset

			//

			// modifier keys are ignored because you can have a sequence

			// that contains modifiers such as "enter ctrl+space" and in most

			// cases the modifier key will be pressed before the next key

			//

			// also if you have a sequence such as "ctrl+b a" then pressing the

			// "b" key will trigger a "keypress" and a "keydown"

			//

			// the "keydown" is expected when there is a modifier, but the

			// "keypress" ends up matching the _nextExpectedAction since it occurs

			// after and that causes the sequence to reset

			//

			// we ignore keypresses in a sequence that directly follow a keydown

			// for the same character

			var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;

			if ( e.type == _nextExpectedAction && !_isModifier( character ) && !ignoreThisKeypress ) {

				_resetSequences( doNotReset );

			}



			_ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';

		};



        /**

         * handles a keydown event

         *

         * @param {Event} e

         * @returns void

         */

		function _handleKeyEvent( e ) {



			// normalize e.which for key events

			// @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion

			if ( typeof e.which !== 'number' ) {

				e.which = e.keyCode;

			}



			var character = _characterFromEvent( e );



			// no character found then stop

			if ( !character ) {

				return;

			}



			// need to use === for the character check because the character can be 0

			if ( e.type == 'keyup' && _ignoreNextKeyup === character ) {

				_ignoreNextKeyup = false;

				return;

			}



			self.handleKey( character, _eventModifiers( e ), e );

		}



        /**

         * called to set a 1 second timeout on the specified sequence

         *

         * this is so after each key press in the sequence you have 1 second

         * to press the next key before you have to start over

         *

         * @returns void

         */

		function _resetSequenceTimer() {

			clearTimeout( _resetTimer );

			_resetTimer = setTimeout( _resetSequences, 1000 );

		}



        /**

         * binds a key sequence to an event

         *

         * @param {string} combo - combo specified in bind call

         * @param {Array} keys

         * @param {Function} callback

         * @param {string=} action

         * @returns void

         */

		function _bindSequence( combo, keys, callback, action ) {



			// start off by adding a sequence level record for this combination

			// and setting the level to 0

			_sequenceLevels[ combo ] = 0;



            /**

             * callback to increase the sequence level for this sequence and reset

             * all other sequences that were active

             *

             * @param {string} nextAction

             * @returns {Function}

             */

			function _increaseSequence( nextAction ) {

				return function() {

					_nextExpectedAction = nextAction;

					++_sequenceLevels[ combo ];

					_resetSequenceTimer();

				};

			}



            /**

             * wraps the specified callback inside of another function in order

             * to reset all sequence counters as soon as this sequence is done

             *

             * @param {Event} e

             * @returns void

             */

			function _callbackAndReset( e ) {

				_fireCallback( callback, e, combo );



				// we should ignore the next key up if the action is key down

				// or keypress.  this is so if you finish a sequence and

				// release the key the final key will not trigger a keyup

				if ( action !== 'keyup' ) {

					_ignoreNextKeyup = _characterFromEvent( e );

				}



				// weird race condition if a sequence ends with the key

				// another sequence begins with

				setTimeout( _resetSequences, 10 );

			}



			// loop through keys one at a time and bind the appropriate callback

			// function.  for any key leading up to the final one it should

			// increase the sequence. after the final, it should reset all sequences

			//

			// if an action is specified in the original bind call then that will

			// be used throughout.  otherwise we will pass the action that the

			// next key in the sequence should match.  this allows a sequence

			// to mix and match keypress and keydown events depending on which

			// ones are better suited to the key provided

			for ( var i = 0; i < keys.length; ++i ) {

				var isFinal = i + 1 === keys.length;

				var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence( action || _getKeyInfo( keys[ i + 1 ] ).action );

				_bindSingle( keys[ i ], wrappedCallback, action, combo, i );

			}

		}



        /**

         * binds a single keyboard combination

         *

         * @param {string} combination

         * @param {Function} callback

         * @param {string=} action

         * @param {string=} sequenceName - name of sequence if part of sequence

         * @param {number=} level - what part of the sequence the command is

         * @returns void

         */

		function _bindSingle( combination, callback, action, sequenceName, level ) {



			// store a direct mapped reference for use with Mousetrap.trigger

			self._directMap[ combination + ':' + action ] = callback;



			// make sure multiple spaces in a row become a single space

			combination = combination.replace( /\s+/g, ' ' );



			var sequence = combination.split( ' ' );

			var info;



			// if this pattern is a sequence of keys then run through this method

			// to reprocess each pattern one key at a time

			if ( sequence.length > 1 ) {

				_bindSequence( combination, sequence, callback, action );

				return;

			}



			info = _getKeyInfo( combination, action );



			// make sure to initialize array if this is the first time

			// a callback is added for this key

			self._callbacks[ info.key ] = self._callbacks[ info.key ] || [];



			// remove an existing match if there is one

			_getMatches( info.key, info.modifiers, { type: info.action }, sequenceName, combination, level );



			// add this call back to the array

			// if it is a sequence put it at the beginning

			// if not put it at the end

			//

			// this is important because the way these are processed expects

			// the sequence ones to come first

			self._callbacks[ info.key ][ sequenceName ? 'unshift' : 'push' ]( {

				callback: callback,

				modifiers: info.modifiers,

				action: info.action,

				seq: sequenceName,

				level: level,

				combo: combination

			} );

		}



        /**

         * binds multiple combinations to the same callback

         *

         * @param {Array} combinations

         * @param {Function} callback

         * @param {string|undefined} action

         * @returns void

         */

		self._bindMultiple = function( combinations, callback, action ) {

			for ( var i = 0; i < combinations.length; ++i ) {

				_bindSingle( combinations[ i ], callback, action );

			}

		};



		// start!

		_addEvent( targetElement, 'keypress', _handleKeyEvent );

		_addEvent( targetElement, 'keydown', _handleKeyEvent );

		_addEvent( targetElement, 'keyup', _handleKeyEvent );

	}



    /**

     * binds an event to mousetrap

     *

     * can be a single key, a combination of keys separated with +,

     * an array of keys, or a sequence of keys separated by spaces

     *

     * be sure to list the modifier keys first to make sure that the

     * correct key ends up getting bound (the last key in the pattern)

     *

     * @param {string|Array} keys

     * @param {Function} callback

     * @param {string=} action - 'keypress', 'keydown', or 'keyup'

     * @returns void

     */

	Mousetrap.prototype.bind = function( keys, callback, action ) {

		var self = this;

		keys = keys instanceof Array ? keys : [ keys ];

		self._bindMultiple.call( self, keys, callback, action );

		return self;

	};



    /**

     * unbinds an event to mousetrap

     *

     * the unbinding sets the callback function of the specified key combo

     * to an empty function and deletes the corresponding key in the

     * _directMap dict.

     *

     * TODO: actually remove this from the _callbacks dictionary instead

     * of binding an empty function

     *

     * the keycombo+action has to be exactly the same as

     * it was defined in the bind method

     *

     * @param {string|Array} keys

     * @param {string} action

     * @returns void

     */

	Mousetrap.prototype.unbind = function( keys, action ) {

		var self = this;

		return self.bind.call( self, keys, function() { }, action );

	};



    /**

     * triggers an event that has already been bound

     *

     * @param {string} keys

     * @param {string=} action

     * @returns void

     */

	Mousetrap.prototype.trigger = function( keys, action ) {

		var self = this;

		if ( self._directMap[ keys + ':' + action ] ) {

			self._directMap[ keys + ':' + action ]( {}, keys );

		}

		return self;

	};



    /**

     * resets the library back to its initial state.  this is useful

     * if you want to clear out the current keyboard shortcuts and bind

     * new ones - for example if you switch to another page

     *

     * @returns void

     */

	Mousetrap.prototype.reset = function() {

		var self = this;

		self._callbacks = {};

		self._directMap = {};

		return self;

	};



    /**

     * should we stop this event before firing off callbacks

     *

     * @param {Event} e

     * @param {Element} element

     * @return {boolean}

     */

	Mousetrap.prototype.stopCallback = function( e, element ) {

		var self = this;



		// if the element has the class "mousetrap" then no need to stop

		if ( ( ' ' + element.className + ' ' ).indexOf( ' mousetrap ' ) > -1 ) {

			return false;

		}



		if ( _belongsTo( element, self.target ) ) {

			return false;

		}



		// Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,

		// not the initial event target in the shadow tree. Note that not all events cross the

		// shadow boundary.

		// For shadow trees with `mode: 'open'`, the initial event target is the first element in

		// the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event

		// target cannot be obtained.

		if ( 'composedPath' in e && typeof e.composedPath === 'function' ) {

			// For open shadow trees, update `element` so that the following check works.

			var initialEventTarget = e.composedPath()[ 0 ];

			if ( initialEventTarget !== e.target ) {

				element = initialEventTarget;

			}

		}



		// stop for input, select, and textarea

		return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;

	};



    /**

     * exposes _handleKey publicly so it can be overwritten by extensions

     */

	Mousetrap.prototype.handleKey = function() {

		var self = this;

		return self._handleKey.apply( self, arguments );

	};



    /**

     * allow custom key mappings

     */

	Mousetrap.addKeycodes = function( object ) {

		for ( var key in object ) {

			if ( object.hasOwnProperty( key ) ) {

				_MAP[ key ] = object[ key ];

			}

		}

		_REVERSE_MAP = null;

	};



    /**

     * Init the global mousetrap functions

     *

     * This method is needed to allow the global mousetrap functions to work

     * now that mousetrap is a constructor function.

     */

	Mousetrap.init = function() {

		var documentMousetrap = Mousetrap( document );

		for ( var method in documentMousetrap ) {

			if ( method.charAt( 0 ) !== '_' ) {

				Mousetrap[ method ] = ( function( method ) {

					return function() {

						return documentMousetrap[ method ].apply( documentMousetrap, arguments );

					};

				}( method ) );

			}

		}

	};



	Mousetrap.init();



	// expose mousetrap to the global object

	window.Mousetrap = Mousetrap;



	// expose as a common js module

	if ( typeof module !== 'undefined' && module.exports ) {

		module.exports = Mousetrap;

	}



	// expose mousetrap as an AMD module

	if ( typeof define === 'function' && define.amd ) {

		define( function() {

			return Mousetrap;

		} );

	}

} )( typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null );

const commandListDelay = {

	'forward': ( token, delay ) => {

		if ( isNumber( token.arg ) ) {
			delay = Math.round( token.arg * 1.5 );
			delay = Math.min( delay, 35 );
		}

		return delay;

	},

	'setbg': () => {
		return 400;
	},

}


const commandList = {

	'fd': [ 'forward', 1 ],
	'forward': [ 'forward', 1 ],

	'bk': [ 'backward', 1 ],
	'back': [ 'backward', 1 ],
	'backward': [ 'backward', 1 ],

	'lt': [ 'left', 1 ],
	'left': [ 'left', 1 ],

	'rt': [ 'right', 1 ],
	'right': [ 'right', 1 ],

	'arc': [ 'arc', 2 ],

	'seta': [ 'seta', 1 ],
	'setangle': [ 'seta', 1 ],
	'setheading': [ 'seta', 1 ],
	'seth': [ 'seta', 1 ],

	'setbg': [ 'setbg', 1 ],

	'color': [ 'colour', 1 ],
	'colour': [ 'colour', 1 ],
	'colorrand': [ 'colourrand' ],
	'colourrand': [ 'colourrand' ],

	'width': [ 'setwidth', 1 ],
	'setwidth': [ 'setwidth', 1 ],
	'setw': [ 'setwidth', 1 ],

	'fill': [ 'fill' ],

	'pu': [ 'penup' ],
	'penup': [ 'penup' ],

	'showcursor': [ 'showcursor' ],
	'hidecursor': [ 'hidecursor' ],

	'pd': [ 'pendown' ],
	'pendown': [ 'pendown' ],

	'home': [ 'home' ],

	'setxy': [ 'setxy', 2 ],
	'position': [ 'setxy', 2 ],
	'setx': [ 'setx', 1 ],
	'sety': [ 'sety', 1 ],

	'delay': [ 'delay', 1 ],
	'wait': [ 'delay', 1 ],

	'clear': [ 'clear' ],

};






/**
 * Split the list of commands up into an array of chunks.
 * We can then loop through all the commands and treat them accordingly.
 *
 * @return {void}
 */
function lexer( text ) {

	const chunks = [];

	// NOTE: Must remember to edit the content in token default switch statement.
	const allowedChars = /[a-z\-\d\$()#]/i;

	let chunk = '';

	for ( const ch of text ) {

		chunk = chunk.trim();

		if ( ch === ' ' || ch === '{' || ch === '}' ) {

			if ( chunk ) {
				chunks.push( chunk );
			}

			if ( ch !== ' ' ) {
				chunks.push( ch );
			}

			chunk = '';

		} else if ( allowedChars.test( ch ) ) {

			chunk += ch;

		}

	}

	if ( chunk ) {
		chunks.push( chunk );
	}

	return chunks;

}



/**
 * Prepare the program for parsing.
 *
 * @return {void}
 */
function prepareText( text ) {

	if ( !text ) {
		return '';
	}

	// Make lowercase.
	text = text.toLowerCase();

	// Remove comments.
	let lines = text.split( /\r?\n/ );
	lines.forEach(
		( value, index ) => {
			lines[ index ] = value.replace( /\/\/.*/g, '' );
		}
	);
	text = lines.join( ' ' );

	// Remove whitespace (duplicate spaces).
	text.replace( /\s+/g, ' ' );

	return text;

}



/**
 * The list of editor commands.
 */
const keywordList = {

	'randseed': [ 'randseed', 1 ],
	'randomseed': [ 'randseed', 1 ],

	'randomize': [ 'randomize' ],
	'randomise': [ 'randomize' ],
	'sausage': [ 'randomize' ],

	'var': [ 'setVar', 2 ],
	// 'difference': [ 'difference', 2 ],
	// 'sum': [ 'sum', 2 ],

};


/**
 * Built in keywords.
 */
const keywords = {


	/**
	 * Change the random seed.
	 *
	 * @param {int} arg The new seed value.
	 * @return {void}
	 */
	randseed: function( arg ) {

		arg = Number( arg );
		arg = Math.abs( arg );
		arg = Math.min( 99999, arg );

		random.seed = arg;

	},


	/**
	 * Change random seed.
	 *
	 * @return {void}
	 */
	randomize: function() {

		random.random_seed();

	},


	/**
	 * Set a variable.
	 *
	 * @param {string} key The variable name.
	 * @param {string} value The variable value.
	 * @return {void}
	 */
	setVar: function( args ) {

		// console.log( 'setVar', args );
		app.parser.setVariable( args );

	},


	// sum: function( value1, value2 ) {

	// },


	// difference: function( value1, value2 ) {

	// },

}
/**
 * Parse the code.
 */
class Parser {

	reservedVariables = [ 'pi', 'e', 'loopcount', 'canvaswidth', 'canvasheight' ];

	/**
	 *
	 */
	constructor( text ) {

		this.text = text;
		this.chunks = [];
		this.functions = [];
		this.tokens = [];
		this.variables = {
			'pi': Math.PI,
			'e': Math.E,
			'repcount': 0,
			'canvaswidth': 512,
			'canvasheight': 512,
		}; // Object to store variables and their values

		// Format text ready for parsing.
		this.text = prepareText( this.text );

		// Convert prepared text into list of chunks.
		this.chunks = lexer( this.text );
		// console.log( 'chunks', this.chunks );

		// Convert chunks into list of commands.
		this.tokenise();

		// Display the tokens.
		// console.table( this.tokens );
		// console.log( 'functions', this.functions );

	}


	/**
	 * Get the next chunk.
	 *
	 * @return {string}
	 */
	nextChunk() {

		// Get the next chunk from the list.
		let chunk = this.chunks.shift();
		// console.log( 'nextChunk', chunk );

		// Everything else.
		switch ( chunk ) {

			case 'random':
			case 'rand':
				return this.parseRandom();

			case 'sum':
			case 'add':
			case 'difference':
			case 'minus':
			case 'multiply':
			case 'times':
			case 'divide':
			case 'over':
			case 'power':
				return this.parseParams( chunk, 2 );

			default:
				return chunk;

		}

	}


	/**
	 * Get next parameters.
	 * This checks for close loops, and stops them from being removed from the list of chunks.
	 *
	 * @return {any}
	 */
	nextParam() {

		let testChunk = this.chunks[ 0 ];

		if ( '}' === testChunk ) {
			return false;
		}

		return this.nextChunk();

	}


	/**
	 * Generate the chunk and it's properties.
	 *
	 * @return {Token}
	 */
	tokenFromChunk( chunk ) {

		// console.log( 'token', chunk );

		switch ( chunk ) {

			case 'repeat':

				return this.parseRepeat();

			case 'function':

				let newFunction = this.parseFunction();
				this.functions[ newFunction.name ] = newFunction.token;

				return;

		}

		let newToken;

		// Generate a token from custom commands.
		newToken = this.commandListToken( commandList, chunk );
		if ( newToken ) { return newToken; }

		// Generate a token from built in commands.
		newToken = this.commandListToken( keywordList, chunk );
		if ( newToken ) { return newToken; }

		return new Token( chunk );

	}


	/**
	 * Generate tokens based upon the specified list of commands.
	 *
	 * @param {array} list The list of commands.
	 * @param {string} chunk The command to search for.
	 * @return {token}
	 */
	commandListToken( list, chunk ) {

		if ( !list ) {
			return false;
		}

		if ( !list[ chunk ] ) {
			return false;
		}

		const command = list[ chunk ];

		if ( command.length > 1 ) {
			switch ( command[ 1 ] ) {
				case 2:
					return new Token( command[ 0 ], [ this.nextParam(), this.nextParam() ] );

				case 3:
					return new Token( command[ 0 ], [ this.nextParam(), this.nextParam(), this.nextParam() ] );

				default:
					return new Token( command[ 0 ], this.nextParam() );

			}
		}

		return new Token( command[ 0 ] );

	}


	/**
	 * Grab nested commands for the repeat command.
	 *
	 * This may need to be simplified so that it's more generic for other
	 * nested properties.
	 *
	 * @return {Token}
	 */
	parseRepeat() {

		const token = new Token( 'repeat' );

		let next = this.nextChunk();

		if ( this.nextChunk() !== '{' ) {
			console.error( 'Error following repeat, expected nn {, got', next );
			return;
		}

		// Don't convert to an int since this could include random numbers and maybe other modifiers.
		token.arg = next;

		while ( ( next = this.nextChunk() ) !== '}' ) {
			token.addCommandToken( this.tokenFromChunk( next ) );
		}

		return token;

	}


	/**
	 * Generate a function from a list of commands.
	 *
	 * @return object
	 */
	parseFunction() {

		const token = new Token( 'function' );

		// Add brackets at the end so that the key matches the function name.
		let name = this.nextChunk() + '()';

		// Check there are commands to run.
		if ( this.nextChunk() !== '{' ) {
			console.error( 'Error creating function, expected {, got', name );
			return;
		}

		// Get the list of commands.
		let next = '';
		while ( ( next = this.nextChunk() ) !== '}' ) {
			token.addCommandToken( this.tokenFromChunk( next ) );
		}

		return { name, token };

	}


	/**
	 * Generate a list of parameters for a command.
	 *
	 * @param {string} arg The command to generate parameters for.
	 * @param {int} count The number of parameters to grab.
	 * @return {string}
	 */
	parseParams( arg = '', count = 2 ) {

		let args = [ arg ];

		// Loop for count times.
		for ( let i = 0; i < count; i++ ) {
			args.push( this.nextChunk() );
		}

		return args.join( ' ' );

	}


	/**
	 * Generate a Random token.
	 *
	 * @return {object}
	 */
	parseRandom() {

		let args = [ 'random' ];

		/**
		 * We look at the chunk data directly.
		 *
		 * When we call nextChunk it removes the item from the array. We don't
		 * want to do this if the next chunk is a token/ command. Accessing the
		 * array directly stops this from happening. We then use nextChunk if
		 * the result is a number.
		 *
		 * We store these first so that we know the values and their positions before we call
		 */
		let next1 = this.chunks[ 0 ];
		let next2 = this.chunks[ 1 ];

		if ( isNumber( next1 ) ) {
			args.push( this.nextChunk() );
		}

		if ( isNumber( next2 ) ) {
			args.push( this.nextChunk() );
		}

		return args.join( ' ' );

	}


	/**
	 * Set the value of a variable.
	 *
	 * @param {array} properties The variable and it's value.
	 * @return {void}
	 */
	setVariable( properties ) {

		const name = properties[ 0 ].replace( '$', '' );

		if ( this.reservedVariables.includes( name ) ) {
			console.error( 'Cannot set reserved variable', name );
			return;
		}

		const value = this.evalMath( properties[ 1 ] );

		this.variables[ name ] = value;
		// console.log( 'setVariable', this.variables );

	}


	/**
	 * Set the value of a reserved variable.
	 * This is used for pi, e, repcount etc.
	 *
	 * @param {string} name The name of the variable.
	 * @param {number} value The value of the variable.
	 * @return {void}
	 */
	setReservedVariable( name, value ) {

		this.variables[ name ] = value;

	}


	/**
	 * Get the value of a variable.
	 *
	 * @param {string} variable The variable to get.
	 * @return {number}
	 */
	getVariable( variable ) {

		// console.log( 'getvariable', variable, this.variables[ variable ] );

		// Return any numbers mistakenly passed in.
		if ( isNumber( variable ) ) {
			return Number( variable );
		}

		// Just in case.
		variable = variable.replace( '$', '' );

		if ( !this.variables[ variable ] ) {
			return 0;
		}

		// console.log( 'getVariable', this.variables[ variable ] );
		return Number( this.variables[ variable ] );

	}


	/**
	 * Evaluate the math.
	 *
	 * @param {string} arg The math to evaluate.
	 * @return {number}
	 */
	evalMath( arg ) {

		if ( isNumber( arg ) ) {
			return Number( arg );
		}

		// console.log( 'evalMath', arg );

		let bits = arg.split( ' ' );

		switch ( bits[ 0 ] ) {

			case 'sum':
			case 'add':
				return this.getVariable( bits[ 1 ] ) + this.getVariable( bits[ 2 ] );

			case 'difference':
			case 'minus':
				return this.getVariable( bits[ 1 ] ) - this.getVariable( bits[ 2 ] );

			case 'multiply':
			case 'times':
				return this.getVariable( bits[ 1 ] ) * this.getVariable( bits[ 2 ] );

			case 'divide':
			case 'over':
				return this.getVariable( bits[ 1 ] ) / this.getVariable( bits[ 2 ] );

			case 'power':
			case 'pow':
				return this.getVariable( bits[ 1 ] ) ** this.getVariable( bits[ 2 ] );

		}

		return arg;

	}


	/**
	 * Generate the Tokens.
	 *
	 * @return {void}
	 */
	tokenise() {

		let chunk;

		this.tokens = [];

		while ( ( chunk = this.nextChunk() ) !== undefined ) {
			const newToken = this.tokenFromChunk( chunk );
			if ( newToken ) {
				this.tokens.push( newToken );
			}
		}

	}

}

class Token {

	/**
	 * Create the token.
	 *
	 * @param {string} type The type of token.
	 * @param {any} arg The argument(s).
	 * @return {void}
	 */
	constructor( type, arg = null ) {

		this.type = type;
		this.arg = this.parseArg( arg );
		this.commands = [];

	}


	/**
	 * Add a command to the current token.
	 *
	 * @param {object} token The command to add.
	 * @return {void}
	 */
	addCommandToken( token ) {

		if ( token ) {
			this.commands.push( token );
		}

	}


	/**
	 * Sanitize the arguments.
	 *
	 * @param {any} arg The argument to sanitize.
	 * @return {any}
	 */
	parseArg( arg ) {

		if ( !arg || arg[ 0 ] === '#' ) {
			return arg;
		}

		switch ( typeof arg ) {

			case 'number':
				return parseFloat( arg, 10 );

			case 'object':
				Object.keys( arg ).forEach(
					( key ) => {
						arg[ key ] = this.parseArg( arg[ key ] );
					}
				);
				return arg;

			case 'array':
				arg.forEach(
					( key ) => {
						arg[ key ] = this.parseArg( arg[ key ] );
					}
				);
				return arg;

			default:
				return arg.replace( /[^a-zA-Z 0-9\-\$#]+/g, '' );

		}

	}

}

// let token1 = new Token( 't', 1 );
// console.log( token1.parseArg( 1 ) );
// console.log( token1.parseArg( 1.111234 ) );
// console.log( token1.parseArg( 'test' ) );
// console.log( token1.parseArg( '#fff' ) );
// console.log( token1.parseArg( '!!!exclame' ) );
// console.log( token1.parseArg( [ '!!!exclame', 1, '#fff' ] ) );
// console.log( token1.parseArg( { a: '!!!exclame', b: 1, c: '#fff' } ) );

class Runner {

	/**
	 * Create the runner.
	 */
	constructor( bot, tokens, functions ) {

		this.bot = bot;
		this.tokens = tokens;
		this.runTokens = [];
		this.functions = functions;
		this.timer = null;

	}


	/**
	 * Run the next command.
	 *
	 * @param {string} token The next command token.
	 * @return false|void
	 */
	runCommand( token = null ) {

		if ( !token ) {
			console.error( 'token empty', token );
			return;
		}

		const { bot } = this;

		const { type, arg, commands } = token;

		if ( 'repcount' === type ) {
			app.parser.setReservedVariable( 'loopcount', arg );
			return;
		}

		// Repeat commands.
		if ( 'repeat' === type ) {

			let method_arg = this.calculateArgs( arg );

			// Ensure the value we are looping over is an int.
			method_arg = parseInt( method_arg );

			// In "repeat tokens" the arg contains the number of loops to make.
			// We count down backwards since the commands are taken from the end of the array.
			for ( let i = method_arg; i > 0; i-- ) {
				// Add the commands to the token loop.
				this.runTokens.unshift( ...commands );
				// Set the repcount variable last because the commands are run in reverse order.
				// From the end of the array to the beginning.
				this.runTokens.unshift( new Token( 'repcount', i ) );
			}

			return;

		}

		// Execute functions.
		if ( this.functions && this.functions[ type ] ) {

			// console.log( 'execute function', type );

			const f = this.functions[ type ];

			// Make sure there's a list of commands with the function.
			if ( f.commands && f.commands.length ) {
				this.runTokens.unshift( ...this.functions[ type ].commands );
				return;
			}

		}

		// Execute built in keywords.
		if ( keywords[ type ] ) {

			// console.log( 'execute keyword', type );

			let method_arg = this.calculateArgs( arg );
			keywords[ type ]( method_arg );
			return;

		}

		// Execute commands.
		if ( commandList[ type ] ) {

			// console.log( 'execute command', type );

			const method = commandList[ type ][ 0 ];

			if ( bot[ method ] ) {

				let method_arg = this.calculateArgs( arg );
				bot[ method ]( method_arg );
				return;

			}

			console.error( 'Command method does not exist', method );

		}

		console.error( `token not known`, type );

	}


	/**
	 * Calculate arguments.
	 *
	 * @param {any} arg The arguments to calculate.
	 * @return {any}
	 */
	calculateArgs( arg ) {

		// console.log( 'calculateArgs', arg );

		/**
		 * We need to make sure we remove the reference when passing the
		 * arguments so that we don't modify the original object properties.
		 */
		let newArg = arg;
		if ( isArray( newArg ) ) {
			newArg = myArray.clone( newArg );
		}

		if ( isString( newArg ) ) {

			// Random numbers.
			if ( newArg.startsWith( 'random' ) ) {

				let values = newArg.replace( 'random ', '' ).split( ' ' );
				newArg = random.integer();

				// We need to check that the numbers are real in case of NaN's popping up.
				if ( 1 === values.length && isNumber( values[ 0 ] ) ) {
					newArg = random.integer( values[ 0 ] );
				}
				if ( 2 === values.length && isNumber( values[ 0 ] ) && isNumber( values[ 1 ] ) ) {
					newArg = random.integer( values[ 0 ], values[ 1 ] );
				}

			}

			// Variables.
			if ( isString( newArg ) && newArg.startsWith( '$' ) ) {

				const variable = newArg.replace( '$', '' );
				newArg = app.parser.getVariable( variable );

			}

			// Math.
			newArg = app.parser.evalMath( newArg );

		}

		// Recursively update if array.
		if ( isArray( newArg ) ) {
			for ( let i = 0; i < newArg.length; i++ ) {
				newArg[ i ] = this.calculateArgs( newArg[ i ] );
			}
			// console.log( 'calculate array', newArg );
		}

		return newArg;

	}


	/**
	 * Run the list of commands.
	 *
	 * @return {void}
	 */
	run() {

		const token = this.runTokens.shift();

		if ( !token ) {
			return;
		}

		/**
		 * Set a delay for the new command.
		 */
		let delay = 5;
		// Call the custom delay function.
		if ( commandListDelay && commandListDelay[ token.type ] ) {
			delay = commandListDelay[ token.type ]( token, delay );
		}

		this.runCommand( token );

		if ( token.type === 'delay' || token.type === 'wait' ) {
			delay = parseInt( token.arg );
		}

		clearTimeout( this.timer );
		this.timer = setTimeout(
			() => {
				this.run();
			},
			delay
		);

		ninjaEvent( 'run_command' );

	}


	/**
	 * Start running the sequence.
	 * Resets everything.
	 *
	 * @param {array} tokens List of tokens.
	 * @return {void}
	 */
	start( tokens = this.tokens ) {

		/**
		 * Clear the timer.
		 *
		 * We need to stop current processes before resetting so that things
		 * don't start in the wrong place.
		 */
		if ( this.timer ) {
			clearTimeout( this.timer );
		}

		ninjaEvent( 'run_begin' );

		random.seed = 0;

		// Reset the runTokens, then start again.
		this.runTokens = tokens;

		// Add a delay before anything happens to prepare the user.
		setTimeout(
			() => {
				this.run();
			},
			500
		);

	}


	/**
	 * Stop everything.
	 *
	 * @return {void}
	 */
	stop() {

		this.runTokens = [];
		clearTimeout( this.timer );

	}

}

const loadCode = {

	/**
	 * Modal.
	 *
	 * @type {object}
	 */
	modal: null,


	/**
	 * List of code items to display.
	 *
	 * @type {array}
	 */
	items: [],


	/**
	 * A link to the function that should be called when the code is loaded.
	 *
	 * @type {function}
	 */
	setCode: null,


	/**
	 * The folder for the thumbnail assets.
	 *
	 * @type {string}
	 */
	assetPrefix: '',


	/**
	 * Display the code picker.
	 *
	 * @return {void}
	 */
	show: function() {

		loadCode.modal = modal.showGeneral( 'Load Code' );
		loadCode.modal.innerHTML = loadCode.template();

		loadCode.modal.addEventListener(
			'click',
			loadCode.click
		);

		[ 'dragenter', 'dragover', 'dragleave', 'drop' ].forEach(
			eventName => {
				loadCode.modal.addEventListener(
					eventName,
					( e ) => {
						e.preventDefault();
						e.stopPropagation();
					},
					false
				);
			}
		);

		loadCode.modal.addEventListener( 'change', loadCode.change );
		loadCode.modal.addEventListener( 'drop', loadCode.dropEvent );

	},


	/**
	 * Change event for file input.
	 *
	 * @param {event} e The change event.
	 * @return {void}
	 */
	change: function( e ) {

		loadCode.loadFile( e.target.files[ 0 ] );

	},


	/**
	 * Drop event for file input.
	 *
	 * @param {event} e The drop event.
	 * @return {void}
	 */
	dropEvent: function( e ) {

		e.preventDefault();

		loadCode.loadFile( e.dataTransfer.files[ 0 ] );

	},


	/**
	 * Load a text file.
	 *
	 * @param {string} file The file contents.
	 * @return {void}
	 */
	loadFile: function( file ) {

		const reader = new FileReader();

		reader.onload = function( e ) {
			loadCode.load( e.target.result );
		};

		reader.readAsText( file );

	},


	/**
	 * Display list of code files that can be loaded.
	 *
	 * @return {string}
	 */
	template: function() {

		let template = '';

		Object.keys( loadCode.items ).forEach(
			( key ) => {
				let item = loadCode.items[ key ];
				let title = item.title;
				if ( item.premium ) {
					title = `${ninja_props.icon_premium} ${title}`;
				}
				template += `<button class="thumbnail thumbnail-fullwidth-image" data-key="${key}">
					<img
						src="/assets/images-code-examples/${loadCode.assetPrefix}/${urlString( key )}.png"
						loading="lazy"
						alt="*"
					/>
					<span class="credit">${title}</span>
				</button>`;
			}
		);

		template = `
			${loadCode.loadFileTemplate()}
			<h2 class="m-b2">Examples</h2>
			<p>Click on an example to load it into the editor.</p>
			<div class="button-grid">${template}</div>
		`;

		return template + loadCode.upsell();

	},


	/**
	 * Load a code ninja file.
	 *
	 * @return {string}
	 */
	loadFileTemplate: function() {

		let html = '';

		html += `
		<label for="file-uploader" class="file-upload">
			Choose a Code Ninja File
			<input type="file" id="file-uploader" accept=".codeninja" />
		</label>
		`;

		return html;

	},


	/**
	 * The template for signed out users with a prompt to join.
	 *
	 * @return {string}
	 */
	templatePremium: function() {

		let template = `<div class="premium">${ninja_props.icon_premium} This example is for members only. <a href="/join/">Join Brush Ninja Members</a> for access to all of the Code Ninja samples, plus lots more.</div>`;
		template += `<button class="loadCode-other button">&larr; Load Different Example</button>`;

		return template;

	},


	/**
	 * Display upgrade message.
	 *
	 * @return {string}
	 */
	upsell: function() {

		let template = '';

		// If not a member.
		if ( !members.isSubscriber() ) {
			template = `<div class=""></div>`;
		}

		return template;

	},


	/**
	 * Click event for items.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	click: function( e ) {

		const key = e.target.getAttribute( 'data-key' );

		if ( key ) {

			e.preventDefault();

			const item = loadCode.items[ key ];

			if ( item.premium & !members.isSubscriber() ) {
				loadCode.modal.innerHTML = loadCode.templatePremium();
				return;
			}

			if ( item && loadCode.setCode ) {
				loadCode.load( loadCode.items[ key ].content );
				return;
			}

		}

		// Revert to the normal template after displaying the upsell screen.
		if ( e.target.classList.contains( 'loadCode-other' ) ) {

			e.preventDefault();
			loadCode.modal.innerHTML = loadCode.template();

		}

	},


	/**
	 * Load the code and reset the modal.
	 *
	 * @param {string} code The code to load.
	 * @return {void}
	 */
	load: function( code ) {

		modal.reset();
		loadCode.setCode( code.trim() );
		ninjaEvent( 'load-code-loaded' )

	},

};


// floodFill.run( ctx, 40, 50, 0xFF0000FF );

/**
 * Floodfill an area with the specified colour.
 *
 * @see https://stackoverflow.com/questions/2106995/how-can-i-perform-flood-fill-with-html-canvas/56221940#56221940
 */
const floodFill = {

	/**
	 * Get the pixelData for the specified position.
	 *
	 * @return {int}
	 */
	getPixel: function( pixelData, x, y ) {

		if ( x < 0 || y < 0 || x >= pixelData.width || y >= pixelData.height ) {
			return -1;  // impossible color
		} else {
			return pixelData.data[ y * pixelData.width + x ];
		}

	},


	/**
	 * Do the flood fill.
	 *
	 * @return {void}
	 */
	run: function( ctx, x, y, fillColor ) {

		x = Math.round( x );
		y = Math.round( y );

		// If the x or y position are out of bounds then quit.
		if ( x < 0 || x > ctx.canvas.width || y < 0 || y > ctx.canvas.height ) {
			return;
		}

		// Read the pixels in the canvas.
		const imageData = ctx.getImageData( 0, 0, ctx.canvas.width, ctx.canvas.height );

		/**
		 * Make a Uint32Array view on the pixels so we can manipulate pixels
		 * one 32bit value at a time instead of as 4 bytes per pixel.
		 */
		const pixelData = {
			width: imageData.width,
			height: imageData.height,
			data: new Uint32Array( imageData.data.buffer ),
		};

		// Get the color we're filling.
		const targetColor = floodFill.getPixel( pixelData, x, y );

		// Check we are actually filling a different color
		if ( targetColor !== fillColor ) {

			const spansToCheck = [];

			/**
			 * Add a new "span" to check.
			 */
			function addSpan( left, right, y, direction ) {
				spansToCheck.push( { left, right, y, direction } );
			}

			/**
			 * Check the specified span.
			 */
			function checkSpan( left, right, y, direction ) {

				let inSpan = false;
				let start;
				let x;
				for ( x = left; x < right; ++x ) {
					const color = floodFill.getPixel( pixelData, x, y );
					if ( color === targetColor ) {
						if ( !inSpan ) {
							inSpan = true;
							start = x;
						}
					} else {
						if ( inSpan ) {
							inSpan = false;
							addSpan( start, x - 1, y, direction );
						}
					}
				}

				if ( inSpan ) {
					inSpan = false;
					addSpan( start, x - 1, y, direction );
				}

			}

			addSpan( x, x, y, 0 );

			// Loop through spans.
			while ( spansToCheck.length > 0 ) {

				const { left, right, y, direction } = spansToCheck.pop();

				// do left until we hit something, while we do this check above and below and add
				let l = left;
				for ( ; ; ) {
					--l;
					const color = floodFill.getPixel( pixelData, l, y );
					if ( color !== targetColor ) {
						break;
					}
				}
				++l

				let r = right;
				for ( ; ; ) {
					++r;
					const color = floodFill.getPixel( pixelData, r, y );
					if ( color !== targetColor ) {
						break;
					}
				}

				const lineOffset = y * pixelData.width;
				pixelData.data.fill( fillColor, lineOffset + l, lineOffset + r );

				if ( direction <= 0 ) {
					checkSpan( l, r, y - 1, -1 );
				} else {
					checkSpan( l, left, y - 1, -1 );
					checkSpan( right, r, y - 1, -1 );
				}

				if ( direction >= 0 ) {
					checkSpan( l, r, y + 1, +1 );
				} else {
					checkSpan( l, left, y + 1, +1 );
					checkSpan( right, r, y + 1, +1 );
				}

			}

			// put the data back
			ctx.putImageData( imageData, 0, 0 );

		}

	}

};

// The direction starts straight up, however, actually its 270deg
// because the co-ordinate system runs from the top.
class Turtle {

	/**
	 * Create and initialize the turtle code.
	 *
	 * @param {object} ctx The canvas context that we will be drawing on.
	 * @return {void}
	 */
	constructor( ctx, cursorCtx ) {

		this.ctx = ctx;
		this.cursorCtx = cursorCtx;

		this.reset();

		document.addEventListener(
			'run_command',
			() => {
				this.updateParams();
				this.drawTurtle();
			}
		);

		document.addEventListener(
			'run_begin',
			() => {
				this.reset();
			}
		);

	}


	/**
	 * Reset the turtle properties.
	 * We should do this before we draw anything.
	 *
	 * @return {void}
	 */
	reset() {

		this.centerX = this.ctx.canvas.width / 2;
		this.centerY = this.ctx.canvas.height / 2;

		this.home();
		this.pendown();
		this.showcursor();
		this.colour( '#fff' );
		this.setbg( 'black' );

		this.ctx.clearRect(
			0,
			0,
			this.ctx.canvas.width,
			this.ctx.canvas.height
		);

		this.ctx.lineWidth = 2;
		this.ctx.lineCap = 'round';
		this.ctx.imageSmoothingEnabled = false;
		this.ctx.filter = 'url(#remove-alpha)';

		this.fillCheck = [];

		this.params_x = document.getElementById( 'code-position-x' );
		this.params_y = document.getElementById( 'code-position-y' );
		this.params_angle = document.getElementById( 'code-position-angle' );

		this.updateParams();
		this.drawTurtle();

	}


	/**
	 * Go to the 'home' location.
	 * The center of the screen.
	 *
	 * @return {void}
	 */
	home() {

		this.seta( 270 );
		this.moveTo( this.centerX, this.centerY );

	}


	/**
	 * Set the x and y position of the drawing point.
	 *
	 * @param {array} values The x and y positions.
	 * @return {void}
	 */
	setxy( values ) {

		this.moveTo( values[ 0 ], values[ 1 ] );

	}


	/**
	 * Set the x position of the drawing point.
	 *
	 * @param {number} value The x position.
	 * @return {void}
	 */
	setx( value ) {

		this.moveTo( value, this.y );

	}


	/**
	 * Set the x position of the drawing point.
	 *
	 * @param {number} value The x position.
	 * @return {void}
	 */
	sety( value ) {

		this.moveTo( this.x, value );

	}


	/**
	 * Set the current angle.
	 *
	 * @param {number} angle The angle in degrees to rotate the pointer to.
	 * @return {void}
	 */
	seta( angle ) {

		this.angle = degrees_to_radians( angle );

	}


	/**
	 * Set the width of the pen.
	 *
	 * @param {number} size The width.
	 * @return {void}
	 */
	setwidth( size ) {

		size = +size;
		size = Math.max( 0, size );

		this.ctx.lineWidth = size;

	}


	/**
	 * Set the background colour.
	 *
	 * Sets the colour on a background div, so we can easily change the colour
	 * without redrawing everything.
	 *
	 * If the canvas is reset then we clear the canvas and do not fill it with
	 * another colour.
	 *
	 * @param {string} color A valid CSS color.
	 * @return {void}
	 */
	setbg( color ) {

		document.getElementById( 'code-wrapper' ).style.background = color;

	}


	/**
	 * Move forward delta pixels.
	 *
	 * @param {number} delta The distance to move forwad.
	 * @return {void}
	 */
	forward( delta ) {

		const newX = this.x + Math.cos( this.angle ) * delta;
		const newY = this.y + Math.sin( this.angle ) * delta;

		this.moveTo( newX, newY );

	}


	/**
	 * Move backwards delta pixels.
	 *
	 * @param {number} delta The distance to move forwad.
	 * @return {void}
	 */
	backward( delta ) {

		this.forward( delta * -1 );

	}


	/**
	 * Fill the current position.
	 *
	 * @return {void}
	 */
	fill() {

		const { x, y } = this;

		// Convert the hex colour into an encoded one.
		let color = this.ctx.fillStyle;
		color = convertColor.run( color );

		// If the x or y position are out of bounds then quit.
		if ( x < 0 || x > this.ctx.canvas.width || y < 0 || y > this.ctx.canvas.height ) {
			return;
		}

		floodFill.run( this.ctx, Math.round( x ), Math.round( y ), color );

	}


	/**
	 * Move to the specified points. This is used by setxy and friends.
	 * This does not need to be called outside the class.
	 *
	 * @param {number} newX The new x position.
	 * @param {number} newY The new y position.
	 * @return {void}
	 */
	moveTo( newX, newY ) {

		// Store the current values.
		const { x, y, ctx, _penDown } = this;

		// Update the position properties.
		this.x = parseFloat( newX );
		this.y = parseFloat( newY );

		if ( _penDown ) {
			ctx.beginPath();
			ctx.moveTo( x, y );	// Set to old position.
			ctx.lineTo( this.x, this.y ); // Draw to new position.
			ctx.stroke();
		}

	}


	/**
	 * Turn right `angle` degrees.
	 *
	 * @param {number} angle The amount to turn in degrees.
	 * @return {void}
	 */
	right( angle ) {

		let newAngle = this.angle + degrees_to_radians( angle );

		if ( newAngle > 2 * Math.PI ) {
			newAngle -= 2 * Math.PI;
		}

		this.angle = newAngle;

	}


	/**
	 * Turn left `angle` degrees.
	 *
	 * @param {number} angle The amount to turn in degrees.
	 * @return {void}
	 */
	left( angle ) {

		let newAngle = this.angle - degrees_to_radians( angle );

		if ( newAngle < 0 ) {
			newAngle += 2 * Math.PI;
		}

		this.angle = newAngle;

	}


	/**
	 * Change the drawing colour.
	 *
	 * @param {number|string} colour The new colour. Can be in hex or CSS colour name format.
	 * @return {void}
	 */
	colour( colour ) {

		this.ctx.strokeStyle = colour;
		this.ctx.fillStyle = colour;

	}


	/**
	 * Pick a random colour that's not dreary.
	 * Generates colours in HSL.
	 *
	 * @return {string}
	 */
	colourrand() {

		const h = random.integer( 0, 360 );
		const s = random.integer( 50, 100 );
		const l = random.integer( 40, 80 );
		let newcolor = `hsl( ${h}, ${s}%, ${l}% )`;

		this.colour( newcolor );

	}


	/**
	 * Draw an arc.
	 *
	 * @param {number} radius The radius of the arc.
	 * @param {number} angle The angle of the arc in degrees.
	 * @return {void}
	 */
	arc( args ) {

		const radius = args[ 0 ];
		const angle = args[ 1 ];

		this.ctx.beginPath();
		this.ctx.arc(
			this.x,
			this.y,
			radius,
			this.angle,
			this.angle + degrees_to_radians( angle )
		);
		this.ctx.stroke();

	}


	/**
	 * Lift up the pen.
	 *
	 * @return {void}
	 */
	penup() {

		this._penDown = false;

	}


	/**
	 * Put down the pen.
	 *
	 * @return {void}
	 */
	pendown() {

		this._penDown = true;

	}


	/**
	 * Update visible parameters.
	 *
	 * @return {void}
	 */
	updateParams() {

		if ( this.params_x ) {
			this.params_x.innerHTML = this.x.toFixed( 1 );
		}
		if ( this.params_y ) {
			this.params_y.innerHTML = this.y.toFixed( 1 );
		}
		if ( this.params_angle ) {
			this.params_angle.innerHTML = radians_to_degrees( this.angle ).toFixed( 1 );
		}

	}


	/**
	 * Show cursor.
	 *
	 * @return {void}
	 */
	showcursor() {

		document.getElementById( 'code-cursor' ).style.display = 'block';

	}


	/**
	 * Hide cursor.
	 *
	 * @return {void}
	 */
	hidecursor() {

		document.getElementById( 'code-cursor' ).style.display = 'none';

	}


	/**
	 * Draw the turtle.
	 *
	 * This is drawn on a separate layer so that it can easily be shown/ hidden.
	 *
	 * @return {void}
	 */
	drawTurtle() {

		if ( !this.cursorCtx ) {
			return;
		}

		const ctx = this.cursorCtx;

		ctx.clearRect(
			0,
			0,
			ctx.canvas.width,
			ctx.canvas.height
		);

		let { x, y, angle } = this;
		const size = 10;

		// Drawing settings.
		ctx.strokeStyle = 'black';
		ctx.fillStyle = 'white';
		ctx.lineWidth = 1.5;
		ctx.lineCap = 'round';

		ctx.save();

		// Translate the origin of the canvas to the center of the shape.
		ctx.translate( x, y );

		// Rotate the canvas by the desired angle.
		angle = radians_to_degrees( angle ) - 270;
		ctx.rotate( degrees_to_radians( angle ) );

		// Draw the shape.
		ctx.beginPath();
		ctx.moveTo( -size, 0 );
		ctx.lineTo( 0, -size * 2.25 );
		ctx.lineTo( size, 0 );
		ctx.lineTo( -size, 0 );

		ctx.fill();
		ctx.stroke();

		ctx.restore();

	}


	/**
	 * A dummy method to delay the drawing.
	 * The code for this is actually in the runner.js file.
	 *
	 * @return {boolean} Always false.
	 */
	delay() {

		return false;

	}

	/**
	 * Clear the canvas.
	 *
	 * @return {void}
	 */
	clear() {

		this.ctx.clearRect(
			0,
			0,
			this.ctx.canvas.width,
			this.ctx.canvas.height
		);

	}

}

function initEditor( target ) {

	CodeMirror.defineMode(
		"logoLike",
		function( config, parserConfig ) {

			const defaultKeywords = [
				'repeat', 'function', 'random', 'rand',
				'sum', 'add', 'difference', 'minus', 'multiply', 'times', 'divide', 'over', 'power', 'pow'
			];
			const keywords = [ ...app.keywordList, ...defaultKeywords ];
			const variable = /^\$[a-zA-Z_]\w*/;
			const number = /^(?:\d+(\.\d*)?|\.\d+)(?:e[+\-]?\d+)?/i;
			const functionCall = /\b\w+\([^)]*\)/;
			const comment = /^\/\/.*/;
			const hexColor = /#[0-9a-fA-F]{3,6}\b/; // Regex for hexadecimal color codes

			return {
				token: function( stream, state ) {
					if ( stream.eatSpace() ) return null;

					if ( stream.match( functionCall ) ) {
						return "function-call";
					}

					if ( stream.match( variable ) ) {
						return "variable";
					}

					if ( stream.match( number ) ) {
						return "number";
					}

					if ( stream.match( comment ) ) {
						return "comment";
					}

					if ( stream.match( hexColor ) ) { // Match hexadecimal color codes
						return "hex-color"; // Apply style for hexadecimal color codes
					}

					const word = stream.match( /\w+/ );
					if ( word && keywords.includes( word[ 0 ].toLowerCase() ) ) {
						return "keyword";
					}

					stream.next();
					return null;
				}
			};
		}
	);

	return CodeMirror.fromTextArea(
		document.getElementById( target ),
		{
			mode: "logoLike",
			indentWithTabs: true,
			tabSize: 2,
			indentUnit: 2,
			electricInput: /^\s*(?:\{|\})$/,
			lineNumbers: true,
			matchBrackets: true,
			closeBrackets: "{[()]}",
			overflowX: 'scroll',
			styleActiveLine: true,
			gutters: [ "CodeMirror-lint-markers" ], // Add gutter for lint markers if needed
		}
	);

}

/**
 * Required default variables.
 *
 * CenterX
 * CenterY
 * Width
 * Height
 * RepeatNumber
 * Pi?
 */

const app = {

	/**
	 * HTML elements.
	 */
	$canvas: null,
	$cursor: null,
	$code: null,

	/**
	 * The Turtle.
	 * @type {Turtle}
	 */
	turtle: null,

	runner: null,

	/**
	 * The current size of the canvas.
	 *
	 * @type {string}
	 */
	currentSize: 'square',

	codeEditor: null,

	parser: null,

	/**
	 * The default code to start with.
	 */
	codeStart: `
setw 4
repeat 4 {
	colorrand
	fd 100
	rt 90
}
		`,

	// 	codeStart: `
	// repeat 20 {
	// 	colorrand
	// 	var side rand 200
	// 	repeat 4 {
	// 		fd $side
	// 		rt 90
	// 	}
	// 	rt rand 360
	// }`,

	/**
	 * Init the app.
	 *
	 * @return {void}
	 */
	init: function() {

		document.addEventListener( 'login-status-change', app.loginStatusChange );

		// Get items.
		app.$canvas = document.getElementById( 'code-drawing' );
		app.$cursor = document.getElementById( 'code-cursor' );

		// Create the Turtle.
		app.turtle = new Turtle( app.$canvas.getContext( '2d' ), app.$cursor.getContext( '2d' ) );

		// Update the highlighting keywords.
		// codeHighlighting.keywords = [ ...Object.keys( commandList ), ...Object.keys( keywordList ) ];
		app.keywordList = [ ...Object.keys( commandList ), ...Object.keys( keywordList ) ];

		// Setup the code editor.
		// app.codeEditor = new CodeEditor( document.querySelector( '#logo-text' ) );
		// app.codeEditor.setHighlighter( codeHighlighting.highlight );
		// app.codeEditor.value = app.codeStart.trim();
		// app.codeEditor.create();

		app.codeEditor = initEditor( 'logo-text' );
		app.setCode( app.codeStart.trim() );

		// Run button.
		const runButton = document.getElementById( 'run' );
		runButton.addEventListener(
			'click',
			app.draw
		);

		// Shortcut key.
		Mousetrap.bind(
			'alt+r',
			app.draw
		);

		app.draw();

		// New code example loaded.
		document.addEventListener(
			'load-code-loaded',
			app.draw
		);

		// Save the output as an image.
		document.getElementById( 'download-image' ).addEventListener(
			'click',
			app.savePng
		);

		// Change canvas size.
		// document.getElementById( 'settings-image-size' ).addEventListener(
		// 	'click',
		// 	app.setSize
		// );

		document.getElementById( 'load-examples' ).addEventListener(
			'click',
			app.loadExamples
		);

		document.getElementById( 'clear-code' ).addEventListener(
			'click',
			( e ) => {
				e.preventDefault();
				app.setCode( '' );
			}
		);

		document.getElementById( 'save-code' ).addEventListener(
			'click',
			( e ) => {
				e.preventDefault();
				downloadTextFile( 'code-ninja.codeninja', app.codeEditor.getValue() );

				shareModal.show(
					'Code Saved',
					'Your code has been saved. You will find it in your Downloads folder!'
				);

			}
		);

	},


	/**
	 * Display Code Ninja for subscribers, and keep it hidden for everyone else.
	 *
	 * @return {void}
	 */
	loginStatusChange: function() {

		if ( members.isSubscriber() ) {

			const $wrappers = document.querySelectorAll( '.brush-ninja-code-ninja' );

			$wrappers.forEach(
				( $elem ) => {
					$elem.style.display = 'block';
				}
			);

			app.codeEditor.update();

			return;

		}

	},


	/**
	 * Run the code.
	 *
	 * @return {void}
	 */
	draw: function() {

		app.turtle.reset();

		// Generate an object with all of the commands and their properties.
		app.parser = new Parser( app.codeEditor.getValue() );

		// Stop existing runner.
		if ( app.runner ) {
			app.runner.stop();
		}

		// Run the commands.
		app.runner = new Runner( app.turtle, app.parser.tokens, app.parser.functions );
		app.runner.start();

	},


	/**
	 * Update the editor code.
	 *
	 * @param {string} newCode The new code.
	 * @return {void}
	 */
	setCode: function( newCode ) {

		app.codeEditor.setValue( newCode.trim() );

	},


	/**
	 * Update the dimensions of the canvas.
	 *
	 * @return {void}
	 */
	// setSize: function() {

	// 	app.currentSize++;
	// 	if ( app.currentSize >)

	// },


	/**
	 * Save an image of the rendered content.
	 *
	 * @return {void}
	 */
	savePng: function() {

		const $wrapper = document.getElementById( 'code-wrapper' );
		$wrapper.classList.add( 'render' );

		/**
		 * Set the scale to 1 so that we don't get blurring.
		 *
		 * Probably don't need the Math.min but keeping it in case I change the
		 * scale for some reason.
		 */
		const canvasScale = Math.min( window.devicePixelRatio, 1 );

		html2canvas(
			$wrapper,
			{
				backgroundColor: null,
				scale: canvasScale,
			}
		).then(
			( canvas ) => {

				const src = canvas.toDataURL( 'image/png' );

				downloadLink( 'code-ninja.png', src );

				$wrapper.classList.remove( 'render' );

				shareModal.show(
					'Image Saved',
					'Your Code Ninja image has been saved. You will find it in your Downloads folder!'
				);

			}
		);

	},


	/**
	 * Load a list of example code.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	loadExamples: function( e ) {

		e.preventDefault();

		loadCode.items = code_2d_examples;
		loadCode.setCode = app.setCode;
		loadCode.assetPrefix = '2d';

		loadCode.show();

	},

};



(
	function() {

		'use strict';

		ready(
			function() {

				app.init();

			}
		);

	}
)();

////=include ./app-code-ninja-2d/demo.js
